// ----------------------------------------------------------------------

// FALLS DIESE ÜBERSETZUNG FALSCH IST, IGNORIEREN SIE DIES BITTE, DA DIESE ÜBERSETZUNG NUR FÜR DEMOZWECKE BESTIMMT IST
// Wir freuen uns, wenn Sie uns bei der Verbesserung der Übersetzung helfen können, indem Sie eine E-Mail an instadrinkpro@gmail.com senden.

// ----------------------------------------------------------------------

const gr = {
  demo: {
    title: `Deutsch`,
    introduction: `Lorem Ipsum ist einfach Dummy-Text der Druck- und Satzindustrie. Lorem Ipsum ist seit dem 16. Jahrhundert der Standard-Dummy-Text der Branche, als ein unbekannter Drucker eine Galeere mit Typen nahm und sie durcheinanderwürfelte, um ein Musterbuch zu erstellen. Es hat nicht nur fünf Jahrhunderte überlebt, sondern auch den Sprung in den elektronischen Satz überdauert und ist im Wesentlichen unverändert geblieben. Es wurde in den 1960er Jahren mit der Veröffentlichung von Letraset-Blättern mit Lorem Ipsum-Passagen populär und in jüngerer Zeit mit Desktop-Publishing-Software wie Aldus PageMaker, die Versionen von Lorem Ipsum enthält.`,
  },
  docs: {
    hi: `Hallo`,
    description: `Brauchen Sie Hilfe? \n Bitte schauen Sie in unsere Dokumentation.`,
    documentation: `Dokumentation`,
  },
  app: `App`,
  user: `Benutzer`,
  list: `Liste`,
  edit: `Bearbeiten`,
  shop: `Shop`,
  blog: `Blog`,
  post: `Beitrag`,
  mail: `E-Mail`,
  chat: `Chat`,
  cards: `Karten`,
  posts: `Beiträge`,
  create: `Erstellen`,
  kanban: `Kanban`,
  general: `Allgemein`,
  banking: `Banking`,
  booking: `Buchung`,
  profile: `Profil`,
  account: `Konto`,
  product: `Produkt`,
  invoice: `Rechnung`,
  details: `Details`,
  checkout: `Zur Kasse`,
  calendar: `Kalender`,
  analytics: `Analysen`,
  ecommerce: `E-Commerce`,
  management: `Verwaltung`,
  menu_level_1: `Menüebene 1`,
  menu_level_2: `Menüebene 2`,
  menu_level_3: `Menüebene 3`,
  item_disabled: `Element deaktiviert`,
  item_label: `Element-Label`,
  item_caption: `Element-Beschriftung`,
  description: `Beschreibung`,
  other_cases: `Andere Fälle`,
  item_by_roles: `Element nach Rollen`,
  only_admin_can_see_this_item: `Nur der Administrator kann dieses Element sehen`,
  create_event: 'Event erstellen',
  label_Rows_Per_Page: 'Zeilen pro Seite',
  created_At: 'Erstellt am',
  location: 'Ort',
  title: 'Titel',
  events: 'Events',
  archived: 'Archiviert',
  canceled: 'Abgesagt',
  Start_Date: 'Event-Startdatum',
  End_Date: 'Event-Enddatum',
  organisation: 'Organisation',
  organisations: 'Organisationen',
  published_events: 'Veröffentlichte Events',
  Add_event: 'Event hinzufügen',
  event_name: 'Event-Name',
  summary: 'Zusammenfassung',
  cancel: 'Abbrechen',
  add: 'Hinzufügen',
  view_event: 'Event anzeigen ',
  event_title: 'Event-Titel',
  cover: 'Cover',
  cover_image: 'Titelbild',
  category: 'Kategorie',
  sub_category: 'Unterkategorie',
  status: 'Status',
  listed: 'Oeffentliches Event',
  listed_tooltip:
    'Wenn aktiviert, wird Ihre Veranstaltung öffentlich sichtbar und von jedermann in der Veranstaltungsliste durchsuchbar sein',
  online_event: 'Online-Event',
  tags: 'Tags',
  address: 'Adresse',
  city: 'Stadt',
  capacity: 'Kapazität',
  save: 'Speichern',
  Start_Time: 'Event-Startzeit',
  End_Time: 'Event-Endzeit',
  timezone: 'Zeitzone',
  Save_Changes: 'Änderungen speichern',
  Quantity: 'Menge',
  Initial_Quantity: 'Verfügbare Menge',
  Max_Quantity: 'Max. pro Bestellung',
  price: 'Preis',
  free: 'Kostenlos',
  Sell_Time_Limit: 'Verkaufszeitlimit',
  delete: 'Löschen',
  Edit: 'Bearbeiten',
  Add_Ticket: 'Ticket hinzufügen',
  Sell_limit: 'Verkaufslimit',
  start: 'Start',
  end: 'Ende',
  Access_Time_Limit: 'Event-Zugriffszeit',
  Price_Quantity: 'Preis und Menge',
  Access_limit: 'Zugriffslimit',
  name: 'Name',
  Your_event_is_already_published_on_this_link:
    'Ihr Event ist bereits unter diesem Link veröffentlicht',
  archive: 'Archivieren',
  Event_Dashboard: 'Event-Dashboard',
  Preview_Event: 'Event-Vorschau',
  publish: 'Veröffentlichen',
  Email_Message: 'Text der E-Mail, die an Ihre Event-Teilnehmer gesendet wird',
  Ticket_Message: 'Ticket-Nachricht',
  include: 'Einschließen',
  required: 'Erforderlich',
  Gender: 'Geschlecht',
  Birthday: 'Geburtstag',
  HomePhone: 'Festnetz',
  yourEventIs: 'Ihr Event ist ',
  date: 'Datum',
  events_catering: 'Event und Catering',
  events_catering_description:
    'ID ist eine Plattform, die es Ihren Kunden ermöglicht, Tickets für Ihre Events zu kaufen und ihre Speisen und Getränke in Ihrem Etablissement digital zu bestellen',
  create_digital_exp: 'Erstellen Sie Ihr digitales Erlebnis',
  create_digital_exp_description:
    'Kunden interagieren mit Ihrer Marke auf Ihre Weise; Sie kontrollieren Ihre digitale Präsenz, um Umsatz und Rentabilität zu maximieren.',
  digital_ticketing: 'DIGITALES TICKETING',
  digital_ticketing_title:
    'Fügen Sie Ihre Events hinzu und verkaufen Sie Tickets auf unserer Plattform.',
  digital_ticketing_description:
    'Jeder Ihrer Kunden, der teilnehmen möchte, kann auf einen Link klicken oder einen QR-Code auf dem digitalen oder physischen Flyer Ihres Events scannen; dies leitet sie zur ID-Plattform, wo sie ihr Ticket auswählen und bezahlen können.',
  more_questions: 'Haben Sie noch Fragen?',
  more_questions_description:
    'Bitte beschreiben Sie Ihren Fall, um die genaueste Beratung zu erhalten.',
  who_are_we: {
    who: 'Wer',
    are: 'sind',
    we: 'wir',
    work: 'Gemeinsam arbeiten für',
    futur: 'eine bessere Zukunft in Events und Catering',
  },
  what_is_id: {
    title: 'Was ist ID?',
    description:
      'ID ist eine Plattform, die es Ihren Kunden ermöglicht, Tickets für Ihre Events zu kaufen und ihre Speisen und Getränke in Ihrem Etablissement digital zu bestellen.',
  },
  about: {
    vision:
      'Unsere Vision: Die perfekte Plattform für eine bessere Zukunft in Events und Catering anbieten.',
    dream_team: 'DREAM TEAM',
    dream_team_description:
      'D wird Ihnen helfen, wenn Sie auf Probleme stoßen. Unser Support-Team wird antworten. Ein gutes Team ist der Schlüssel. Innerhalb eines Tages, und wir haben auch eine detaillierte Dokumentation.',
  },
  testimonials: {
    title: 'TESTIMONIALS',
    who: 'Wer mag',
    service: ' unseren Service?',
    description:
      'Unser Ziel ist es, die perfekte Plattform zu schaffen, die alle unsere Kunden im Event- und Cateringbereich zufriedenstellt. Deshalb arbeiten wir ständig an unseren Dienstleistungen, um sie jeden Tag zu verbessern, indem wir auf die wertvollen Vorschläge hören, die unsere Nutzer mit uns teilen.',
  },
  Min_Quantity: 'Min. pro Bestellung',
  save_continue: 'Speichern und fortfahren',
  continue_later: 'Nicht speichern und später fortfahren',
  Link_to_buy_tickets_for_your_event: 'Link zum Ticketkauf für Ihr Event',
  back: 'Zurück',
  Complete_the_details_of_the_event_to_be_able_to_publish_it:
    'Vervollständigen Sie die Details des Events, um es veröffentlichen zu können',
  publish_the_event: 'Event veröffentlichen',
  view: 'Ansehen',
  ready_events: 'Fertige Events',
  drafted_events: 'Entwürfe',
  archived_events: 'Archivierte Events',
  canceled_events: 'Abgesagte Events',
  no_events: 'Keine Events',
  my_events: 'Meine Promo Events',
  total_sold: 'Gesamtumsatz',
  sold_quantity: 'Anzahl verkaufter Tickets',
  send_batch_emails: 'Massen-E-Mails senden',
  event_link: 'Event-Link',
  sale_date: 'Verkaufsdatum',
  validated: 'Validiert',
  confirmed: 'Bestätigt',
  reimbursed: 'Erstattet',
  About: 'Über',
  Name: 'Name',
  promoters: 'PromoBooster',
  add_promoter: 'PromoBooster hinzufügen',
  choose_promoter: 'PromoBooster auswählen',
  remove: 'Entfernen',
  min_followers: 'Mindestanzahl Follower',
  Dashboard: 'Dashboard',
  General: 'Allgemein',
  Preview: 'Vorschau',
  required_information: 'Erforderliche Informationen',
  promo_code: 'Promo-Codes',
  overview: 'Übersicht',
  preview_your_event: 'Event-Vorschau',
  Owner: 'Eigentümer',
  create_org: 'Organisation erstellen',
  Account: 'Konto',
  account_settings: 'Kontoeinstellungen',
  Allowed_format: 'Erlaubte Formate',
  max_size: 'max. Größe von',
  billing: 'Abrechnung',
  Email_Address: 'E-Mail-Adresse',
  Phone_Number: 'Telefonnummer',
  Country: 'Land',
  State_Region: 'Bundesland/Region',
  Zip_Code: 'PLZ',
  discount: 'Rabatt',
  maximum_number_of_sold_tickets: 'maximale Anzahl verkaufter Tickets',
  Featured_tickets: 'Hervorgehobene Tickets',
  No_promo_code_available: 'Kein Promo-Code verfügbar',
  add_promo_code: 'Promo-Code hinzufügen',
  This_code_is_already_used: 'Dieser Code wird bereits verwendet!',
  discount_amount: 'Rabattbetrag',
  advanced_options: 'Erweiterte Optionen',
  all_tickets: 'Alle Tickets',
  specific_tickets: 'Spezifische Tickets',
  Legal_info: 'Rechtliche Informationen',
  Followers: 'Follower',
  Total_events: 'Gesamtanzahl Events',
  Recommended: 'Empfohlen',
  company_name: 'Firmenname',
  company_number: 'Firmennummer',
  Website: 'Website',
  Cover: 'Titelbild',
  add_organisation: 'Organisation hinzufügen',
  create_user: 'Benutzer erstellen',
  users: 'Benutzer',
  firstname: 'Vorname',
  lastname: 'Nachname',
  role: 'Rolle',
  access: 'Zugriff',
  events_permissions: 'Event-Berechtigungen',
  organisations_permissions: 'Organisations-Berechtigungen',
  Yes: 'Ja',
  No: 'Nein',
  Permissions: 'Berechtigungen',
  Editing: 'Bearbeitung',
  Roles: 'Rollen',
  Search: 'Suchen',
  Event_stats: 'Event-Statistiken',
  sales: 'Verkäufe',
  Number_of_purchase: 'Anzahl der Käufe',
  Link: 'Link',
  sold: 'verkauft',
  available: 'verfügbar',
  Tickets_status: 'Ticket-Status',
  There_is_no_tickets_status_for_this_event: 'Es gibt keinen Ticket-Status für dieses Event',
  promoter: 'PromoBooster',
  invite_user: 'Benutzer einladen',
  published: 'Veröffentlicht',
  ready: 'Bereit',
  draft: 'Entwurf',
  initial: 'Initial',
  upcoming: 'Bevorstehend',
  ongoing: 'Laufend',
  past: 'Vergangen',
  Organisation: 'Organisation',
  Bio: 'Bio',
  Type: 'Typ',
  Evenementiel: 'Events',
  Restaurant: 'Restaurant',
  Email: 'E-Mail',
  Drop_or_Select_file: 'Datei ablegen oder auswählen',
  Rajoutez_une_image_de_couverture_pour_votre_événement:
    'Fügen Sie ein Titelbild für Ihr Event hinzu',
  Upload_photo: 'Foto hochladen',
  Update_photo: 'Foto aktualisieren',
  organisation_users: 'Organisationsbenutzer',
  Agent_liés_à_lorganisation: 'Mit der Organisation verbundene Agenten',
  Agents_en_attente_de_confirmation: 'Agenten warten auf Bestätigung',
  Instadrink_admin: 'I.D-Administrator',
  create_role: 'Rolle erstellen',
  Predefined_roles: 'Vordefinierte Rollen',
  Custom_roles: 'Benutzerdefinierte Rollen',
  Agents: 'Agenten',
  Organizer: 'Organisator',
  Bouncer: 'Türsteher',
  Ambassador: 'Botschafter',
  promotion_groups: 'PromoBooster-Gruppen',
  Dates: 'Termine',
  Tickets: 'Tickets',
  Messages: 'Nachrichten',
  Promotion: 'Werbung',
  Participants: 'Teilnehmer',
  Client: 'Kunde',
  description_placeholder:
    'Beschreiben Sie Ihren zukünftigen Teilnehmern die außergewöhnliche Atmosphäre, die bei Ihrer Veranstaltung herrschen wird.',
  Tickets_collection: 'Ticketsammlung',
  Stop_sell_time_is_at: 'Verkaufsstopp ist um',
  drag_and_drop: 'Ziehen und ablegen, um die Reihenfolge zu ändern',
  delete_ticket_confirmation: 'Sind Sie sicher, dass Sie dieses Ticket löschen möchten?',
  Access_Time_Thresholdt: 'Endzeitpunkt für den Veranstaltungszugang',
  order: 'Bestellung',
  Créez_les_tickets_pour_votre_événement: 'Erstellen Sie Tickets für Ihre Veranstaltung',
  stop_sell_time_error_message:
    'Das Enddatum muss nach dem Startdatum liegen und darf das Verkaufsstopp-Datum nicht überschreiten',
  Reset: 'Zurücksetzen',
  send_invitation: 'Einladung senden',
  Tickets_quantity_error_message: 'Plätze sind noch verfügbar',
  Write_something_awesome: 'Schreiben Sie etwas Großartiges...',
  Code: 'Code',
  delete_promocode_confirm_message: 'Sind Sie sicher, dass Sie diesen Code löschen möchten?',
  Activate_promotion: 'Werbung aktivieren',
  Desactivate_promotion: 'Werbung deaktivieren',
  Configure_RP_offer: 'PromoBooster-Angebot konfigurieren',
  promotion_status: 'Werbungsstatus',
  TooltipTextForPromotionGroups:
    'In diesem Abschnitt können Sie Ressourcenpersonen-Gruppen (RPs) für Ihre Veranstaltungen erstellen und verwalten',
  TooltipTextForEventLink:
    'Veröffentlichen Sie Ihre Veranstaltung, um den Veranstaltungslink zu erhalten',
  TooltipTextForPromotionGroupsForReferral:
    'In diesem Abschnitt finden Sie die PromoBooster-Gruppen, denen Sie angehören, und Sie können die Gruppe jederzeit verlassen.',
  confirm_delete_promoter: 'Sind Sie sicher, dass Sie diesen PromoBooster löschen möchten?',
  Preview_promoter_link: 'Vorschau des PromoBooster-Links',
  Locked: 'Gesperrt',
  pending: 'ausstehend',
  accepted: 'akzeptiert',
  rejected: 'abgelehnt',
  Publish_my_event_now: 'Meine Veranstaltung jetzt veröffentlichen',
  publish_later: 'Später veröffentlichen',
  Your_event_is_still_draft:
    'Ihre Veranstaltung ist noch ein Entwurf, vervollständigen Sie die Konfiguration, um sie zu veröffentlichen',
  Are_you_sure_to_publish_the_event:
    'Sind Sie sicher, dass Sie die Veranstaltung veröffentlichen möchten ',
  pourcentage: 'Prozentsatz',
  Rate: 'Rate',
  Message: 'Nachricht',
  submit: 'Absenden',
  Create_group: 'Gruppe erstellen',
  Groups: 'Gruppen',
  Edit_group: 'Gruppe bearbeiten',
  Search_by_Name: 'Nach Namen suchen',
  Enter_group_name: 'Gruppennamen eingeben',
  No_promoters_found: 'Keine Promoter gefunden',
  Add_group: 'Gruppe hinzufügen',
  Number_of_sales: 'Anzahl der Verkäufe',
  Turnover: 'Umsatz',
  Number_of_clients: 'Anzahl der Kunden',
  Promotion_requests: 'Werbe-Anfragen',
  Requests: 'Anfragen',
  Notifications: 'Benachrichtigungen',
  Referral_requests: 'PromoBooster-Anfragen',
  no_requests: 'Es gibt keine Anfragen',
  request_message: 'hat Ihnen eine Anfrage gesendet, um Sie als PromoBooster einzuladen für',
  Accept: 'Akzeptieren',
  Reject: 'Ablehnen',
  Your_invitation_to: 'Ihre Einladung zu',
  on: 'am',
  at: 'um',
  is: 'ist',
  promotion_rate: 'Werbesatz',
  consigne: 'Anweisung',
  Cancel_request: 'Anfrage abbrechen',
  Send_request: 'Anfrage senden',
  No_events: 'Finden Sie eine Veranstaltung, bei der Sie als PromoBooster zusammenarbeiten möchten',
  Search_for_new_events: 'Nach neuen Veranstaltungen suchen',
  Search_for_Events: 'Nach Veranstaltungen suchen',
  Sales_stats: 'Verkaufsstatistiken',
  Total_sales: 'Gesamtverkäufe',
  Total_reservation: 'Gesamtreservierungen',
  Bienvenue_message: 'Willkommen bei I.D, wählen Sie Ihren Bereich',
  second_bienvenu_message:
    'Willkommen bei I.D, wählen Sie Ihre Branche zwischen Veranstaltungen und Catering.',
  Continue: 'Fortfahren',
  Event: 'Veranstaltung',
  orga_message: 'Wählen Sie die Organisation, unter der Sie Ihre Veranstaltung erstellen werden',
  Skip: 'Überspringen',
  All_steps_completed: 'Alle Schritte abgeschlossen',
  you_have_finished: 'Sie haben abgeschlossen',
  limit_sell_message: 'Geben Sie ein Limit-Datum und -Uhrzeit für den Ticketverkauf ein',
  stopSellDate: 'Verkaufsstopp-Datum für Tickets',
  status_tooltip:
    'Dieses Statusfeld berechnet automatisch das Start- und Enddatum und gibt Ihnen den Veranstaltungsstatus',
  Step: 'Schritt',
  correct_start_date: 'Korrigieren Sie das vergangene Startdatum',
  Finish: 'Abschließen',
  event_name_tooltip: 'Wie lautet der Name Ihrer Veranstaltung?',
  event_summary_tooltip:
    'Geben Sie einen Einblick in die schönen Überraschungen, die zukünftige Teilnehmer bei Ihrer Veranstaltung erwarten.',
  event_description_tooltip:
    'Beschreiben Sie diesmal detailliert die Veranstaltung, an der zukünftige Teilnehmer teilnehmen werden.',
  event_cover_tooltip: 'Wählen Sie ein Foto für Ihre Veranstaltung.',
  organisation_tooltip:
    'Wählen Sie den Namen der Organisation, die Ihre Veranstaltung ausrichten wird.',
  category_tooltip: 'Wählen Sie eine Kategorie für Ihre Veranstaltung.',
  subCategory_tooltip: 'Wählen Sie eine Unterkategorie für Ihre Veranstaltung.',
  Rp_request: 'hat Ihnen eine Anfrage gesendet, um PromoBooster seiner Veranstaltung zu werden',
  warning_message:
    'Bitte drücken Sie zuerst "Hinzufügen", um Ihr Ticket zu speichern und fortzufahren',
  correct_date_tooltip:
    'Das ausgewählte Startdatum für Ihre Veranstaltung liegt bereits in der Vergangenheit.',
  step1:
    'In diesem Schritt finden Sie die Verkaufsstatistiken der Veranstaltung und die Teilnehmerliste für die Veranstaltung.',
  step2: 'In diesem Schritt können Sie die Details der Veranstaltung bearbeiten.',
  step3: 'In diesem Schritt können Sie die Daten und Zeiten der Veranstaltung bearbeiten.',
  step4:
    'In diesem Schritt können Sie neue Tickets für Ihre Veranstaltung hinzufügen oder bestehende Tickets bearbeiten.',
  step5: 'In diesem Schritt können Sie Ihre Veranstaltung veröffentlichen oder archivieren.',
  step6:
    'In diesem Schritt finden Sie die Veranstaltungsansicht für Kunden in der Desktop- oder Mobilansicht.',
  step7: 'In diesem Schritt finden Sie die Übersicht über Ihre Veranstaltungsdetails.',
  step8: 'In diesem Schritt können Sie Informationen über die Veranstaltung hinzufügen.',
  stepCodePromo: 'In diesem Schritt können Sie Promo-Codes für die Tickets hinzufügen.',
  step10:
    'In diesem Schritt können Sie die RPs für Ihre Veranstaltung verwalten, eine Gruppe von RPs erstellen oder Anfragen an den PromoBooster senden, um PromoBooster Ihrer Veranstaltung zu werden.',
  step11: 'In diesem Schritt finden Sie die Liste der Teilnehmer.',
  total_sold_tooltip: 'Dies ist der Gesamtverkaufspreis für die Veranstaltungstickets',
  sold_quantity_tooltip: 'Dies ist die Gesamtverkaufsmenge für die Veranstaltungstickets',
  link_tooltip: 'Dies ist der Veranstaltungslink zum Kauf Ihrer Tickets.',
  table_tooltip:
    'Hier ist die Tabelle, in der Sie die Liste der Teilnehmer für diese Veranstaltung finden.',
  create_event_button_tooltip: 'Klicken Sie hier, um eine neue Veranstaltung zu erstellen.',
  events_table_tooltip:
    'Dies ist die Veranstaltungstabelle, in der Sie Ihre Veranstaltungsdetails finden können.',
  You_have_no_organisations: 'Sie haben keine Organisationen',
  alert_orga_title:
    'Sie müssen eine Organisation erstellen, damit Sie danach eine Veranstaltung erstellen können.',
  Configurate_here: 'Hier konfigurieren',
  legal_verification: 'Rechtliche Überprüfung Ihres Kontos',
  alert_stripe_configuration_title:
    'Bitte vervollständigen Sie Ihre rechtlichen Informationen, um Ihr Konto zu aktivieren und Ihre Tickets verkaufen zu können.',
  Bank_balance: 'Bankguthaben',
  View_my_Stripe_account: 'Mein Stripe-Konto anzeigen',
  Your_balance: 'Ihr Guthaben',
  Add_new_card: 'Neue Karte hinzufügen',
  Name_on_card: 'Name auf der Karte',
  Card_number: 'Kartennummer',
  Expiration_date: 'Ablaufdatum',
  QRcode_tooltip:
    'Klicken Sie hier, um den QR-Code Ihrer Veranstaltung anzupassen und herunterzuladen',
  File_Type: 'Dateityp',
  Size: 'Größe',
  Color: 'Farbe',
  Background_Color: 'Hintergrundfarbe',
  Download_QR_Code: 'QR-Code herunterladen',
  Download_Invoice: 'Rechnung herunterladen',
  show_qr_code: 'QR-Code anzeigen',
  Close: 'Schließen',
  Customize_QR_Code: 'QR-Code anpassen',
  no_users_yet: 'Noch keine Benutzer',
  plz_invite_users: 'Bitte laden Sie Benutzer ein',
  invite_organizer: 'Organisator einladen',
  invite: 'Einladen',
  settings: 'Einstellungen',
  invite_owners: 'Besitzer einladen',
  register: 'Registrieren',
  password: 'Passwort',
  confirm_password: 'Passwort bestätigen',
  email_adress: 'E-Mail-Adresse',
  division_agent: 'Agent',
  division_promoter: 'Promoter',
  iam_owner: 'Ich bin ein Besitzer',
  iam_owner_desc: 'Verwalten Sie Ihre Organisationen, Restaurants und Veranstaltungen',
  iam_amb: 'Ich bin ein Botschafter',
  iam_amb_desc: 'Fördern Sie Organisationen und verdienen Sie Provisionen',
  iam_ref: 'Ich bin ein PromoBooster',
  iam_ref_desc: 'Empfehlen Sie Veranstaltungen und verdienen Sie Provisionen',
  start_free: 'Kostenlos starten',
  no_credit_card: 'Keine Kreditkarte erforderlich',
  have_account: 'Haben Sie bereits ein Konto?',
  by_register_1: 'Mit der Registrierung stimme ich den I.D ',
  by_register_2: 'Nutzungsbedingungen',
  by_register_3: ' und der ',
  by_register_4: 'Datenschutzrichtlinie zu.',
  manager_better_register: 'Verwalten Sie Veranstaltungen effizienter mit I.D',
  referral: 'PromoBooster',
  first_name_required: 'Vorname erforderlich',
  first_name_short: 'Vorname ist zu kurz - sollte mindestens 3 Zeichen lang sein.',
  first_name_long: 'Vorname ist zu lang - sollte maximal 50 Zeichen lang sein.',
  first_name_alpha: 'Vorname darf nur alphabetische Zeichen enthalten.',
  last_name_required: 'Nachname erforderlich',
  last_name_short: 'Nachname ist zu kurz - sollte mindestens 3 Zeichen lang sein.',
  last_name_long: 'Nachname ist zu lang - sollte maximal 50 Zeichen lang sein.',
  last_name_alpha: 'Nachname darf nur alphabetische Zeichen enthalten.',
  email_invalid: 'E-Mail muss eine gültige E-Mail-Adresse sein',
  email_required: 'E-Mail ist erforderlich',
  password_required: 'Passwort ist erforderlich',
  password_short: 'Passwort ist zu kurz - sollte mindestens 8 Zeichen lang sein.',
  password_long: 'Passwort ist zu lang - sollte höchstens 128 Zeichen lang sein.',
  password_alpha: 'Passwort darf nur lateinische Buchstaben enthalten.',
  password_lowercase: 'Passwort muss mindestens einen Kleinbuchstaben enthalten.',
  password_uppercase: 'Passwort muss mindestens einen Großbuchstaben enthalten.',
  password_number: 'Passwort muss eine Zahl enthalten.',
  password_special: 'Passwort muss mindestens ein Sonderzeichen enthalten.',
  password_no_repeat:
    'Passwort darf nicht denselben Buchstaben dreimal hintereinander wiederholen.',
  confirm_password_match: 'Passwörter müssen übereinstimmen',
  confirm_password_required: 'Passwort bestätigen ist erforderlich',
  division_required: 'Abteilung ist erforderlich',
  division_invalid: 'Abteilung muss entweder Promoter oder Agent sein',
  role_required: 'Rolle ist erforderlich',
  role_invalid_promoter: 'Ungültige Rolle für Promoter',
  role_invalid_agent: 'Ungültige Rolle für Agent',
  login: 'Anmelden',
  fr: 'Französisch',
  en: 'Englisch',
  es: 'Spanisch',
  pt: 'Portugiesisch',
  lang: 'Sprache',
  creating_account: 'Konto wird erstellt',
  creating_account_desc: 'Abschließen Ihrer Kontoeinrichtung',
  creating_account_info:
    'Ihr Konto wird derzeit eingerichtet. Bitte bleiben Sie auf dieser Seite, bis der Vorgang abgeschlossen ist. Wir danken Ihnen für Ihre Geduld!',
  accept_invitation_info:
    'Bitte beachten Sie, dass Sie nach Annahme der unten stehenden Einladung eine Bestätigungs-E-Mail erhalten werden. Nach der Bestätigung können Sie Ihre Kontoeinrichtung abschließen, einschließlich der Möglichkeit, Ihren Namen und Ihre bevorzugte Sprache zu ändern.',
  invitation_already_processed:
    'Diese Einladung wurde bereits verarbeitet. Bitte überprüfen Sie Ihr Event-Dashboard für weitere Informationen.',
  'invitation.continuation_title': 'Einladung bereits gesendet!',
  'invitation.continuation_body':
    'Für diese E-Mail wurde bereits eine Einladung versendet. Bitte prüfen Sie Ihren Posteingang (und den Spam-Ordner) und klicken Sie auf den Verifizierungslink.\n\nWenn Sie die E-Mail nicht finden, können Sie fortfahren, indem Sie auf die Schaltfläche <0>Erneut einladen</0> tippen.',
  'invitation.continuation_use_existing': 'Ich prüfe meine E-Mails',
  'invitation.continuation_start_new': 'Erneut einladen',
  cancel_successful: 'Einladung abgebrochen',
  cancel_failed: 'Einladung konnte nicht abgebrochen werden',
  verify_email: 'Bestätigen Sie Ihre E-Mail',
  verify_email_desc: 'Konto erfolgreich erstellt',
  account_created_check_email:
    'Konto erfolgreich erstellt. Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu bestätigen und vollen Zugriff zu erhalten.',
  thanks_join_invite: 'Vielen Dank, dass Sie unserer Community beigetreten sind!',
  verify_before_expire: 'Bestätigen Sie Ihre E-Mail, bevor sie abläuft',
  verify_email_info:
    'Herzlichen Glückwunsch zur Einrichtung Ihres Kontos! Bitte überprüfen Sie Ihren E-Mail-Posteingang, um Ihr Konto zu bestätigen und vollen Zugriff zu erhalten.',
  wait_verify: 'Bitte warten Sie einen Moment, während wir Ihre E-Mail überprüfen.',
  wait_redirect: 'Schließen Sie dieses Fenster nicht, bis Sie zum Dashboard weitergeleitet wurden.',
  initialAccountHeader: 'Schließen Sie Ihr I.D-Konto ab',
  initialAccountDescription:
    'Willkommen zurück! Legen Sie unten einfach Ihr Passwort fest, um die Einrichtung Ihres Kontos abzuschließen.',
  initialAccountButton: 'Einrichtung abschließen',
  processingAccountHeader: 'Ihr Konto wird eingerichtet...',
  processingAccountDescription:
    'Bitte warten Sie einen Moment, während wir Ihre Daten bestätigen und Ihr Konto sichern.',
  processingAccountButton: 'Wird abgeschlossen...',
  successAccountHeader: 'Erfolg! Konto bereit',
  successAccountDescription:
    'Ihr Konto wurde erfolgreich eingerichtet und Sie werden angemeldet. Sie werden in Kürze zum Dashboard weitergeleitet.',
  successAccountButton: 'Weiterleitung...',
  errorAccountHeader: 'Etwas ist schiefgelaufen',
  errorAccountDescription:
    'Bei der Einrichtung Ihres Kontos ist ein Problem aufgetreten. Der Link ist möglicherweise ungültig oder abgelaufen, oder die E-Mail-Adresse könnte falsch sein.',
  errorAccountButton: 'Erneut versuchen',
  linkexpiredAccountHeader: 'Überprüfen Sie Ihre E-Mail',
  linkexpiredAccountDescription:
    'Bei der Einrichtung Ihres Kontos ist ein Problem aufgetreten. Der Link ist möglicherweise ungültig oder abgelaufen, oder die E-Mail-Adresse könnte falsch sein.',
  verification_expired:
    'Kontoeinrichtung fehlgeschlagen! Der Bestätigungslink für Ihr Konto ist abgelaufen.',
  new_verification_link_sent: 'Ein neuer Bestätigungslink wurde an Ihre E-Mail-Adresse gesendet.',
  login_welcome: 'Hallo, Willkommen',
  login_connect: 'Bei I.D anmelden',
  login_type: 'Geben Sie unten Ihre Daten ein.',
  login_no_account: 'Sie haben noch kein Konto?',
  login_register: 'Registrieren',
  owner_total_part: 'Dies sind die Anteile des Besitzers am Verkauf der Event-Tickets.',
  my_share: 'Mein Anteil',
  Remember_password: 'Passwort merken',
  forgot_password: 'Passwort vergessen?',
  create_your_first_organization: 'Erstellen Sie Ihre erste Organisation',
  create_organization_step_description:
    'Um mit der Verwaltung Ihrer Events zu beginnen. Erstellen Sie Ihre erste Organisation. Sie können später so viele Organisationen erstellen, wie Sie möchten.',
  create_your_first_event: 'Erstellen Sie Ihr erstes Event',
  create_event_step_description:
    'Nachdem Sie Ihre erste Organisation erstellt haben, ist es Zeit, kurz Ihr erstes Event zu erstellen. Sie können es später im Detail bearbeiten.',
  congratulations: 'Herzlichen Glückwunsch!',
  last_step_description:
    'Sie können jetzt zur Eventliste navigieren und mit der Erstellung Ihres Events fortfahren',
  create_your_first_restaurant: 'Erstellen Sie Ihr erstes Restaurant',
  create_restaurant_step_description:
    'Um mit der Verwaltung Ihrer Tische zu beginnen. Erstellen Sie Ihr erstes Restaurant. Sie können später so viele Restaurants erstellen, wie Sie möchten.',
  create_restaurant_last_step_description:
    'Sie können jetzt zur Restaurantliste navigieren und mit der Erstellung Ihrer Tische fortfahren',
  Logout: 'Abmelden',
  Settings: 'Einstellungen',
  create_store: 'Shop erstellen',
  add_category: 'Kategorie hinzufügen',
  add_new_product: 'Neues Produkt hinzufügen',
  add_new_category: 'Neue Kategorie hinzufügen',
  products: 'Produkte',
  categories: 'Kategorien',
  unavailable: 'Nicht verfügbar',
  composite: 'Zusammengesetzt',
  alcoholic: 'Alkoholisch',
  Available: 'Verfügbar',
  Description: 'Beschreibung',
  simple: 'Einfach',
  search_product: 'Produkt suchen...',
  min_price: 'Mindestpreis',
  max_price: 'Höchstpreis',
  add_product: 'Produkt hinzufügen',
  edit_product: 'Produkt bearbeiten',
  product_details: 'Produktdetails',
  composition_items: 'Zusammensetzungselemente',
  caption: 'Bildunterschrift',
  extra: 'Extra',
  max_quantity: 'Maximale Menge',
  add_composition: 'Zusammensetzung hinzufügen',
  items: 'Artikel',
  item_name: 'Artikelname',
  add_item: 'Artikel hinzufügen',
  preparation_time: 'Zubereitungszeit',
  Orders: 'Bestellungen',
  current_orders: 'Aktuelle Bestellungen',
  store: 'Shop',
  no_stores_message:
    'Sie haben keine Shops, um Bestellungen zu sehen. Bitte erstellen Sie zuerst einen',
  Pending: 'Ausstehend',
  in_preparation: 'In Vorbereitung',
  Preparation: 'Vorbereitung',
  accept_order: 'Bestellung annehmen',
  order_is_ready: 'Bestellung ist fertig',
  finish_order: 'Bestellung abschließen',
  total: 'Gesamt',
  order_of: 'Bestellung von',
  Contact: 'Kontakt',
  reservations_shares: 'Reservierungsanteile',
  client_name: 'Kundenname',
  total_amount: 'Gesamtbetrag',
  owner_share: 'Besitzeranteil',
  instadrink_share: 'I.D-Anteil',
  rp_share: 'PromoBooster-Anteil',
  ambassador_share: 'Botschafter-Anteil',
  shares_distribution: 'Anteilsverteilung',
  group_name: 'Gruppenname',
  group_members: 'Gruppenmitglieder',
  created_by: 'Erstellt von',
  leave_group: 'Gruppe verlassen',
  with_product: 'Mit Produkt',
  all_categories: 'Alle Kategorien',
  inclusives: 'Inklusives',
  closing_Time: 'Schließzeit',
  open: 'Offen',
  Rush_hour: 'Stoßzeit',
  preview_store: 'Shop-Vorschau',
  Delete_account: 'Konto löschen',
  Are_you_sure_you_want_to_delete_your_account:
    'Sind Sie sicher, dass Sie Ihr Konto löschen möchten',
  delete_account_page_message:
    'Wenn Sie sich für die Löschung Ihres Kontos entscheiden, wählen Sie die dauerhafte Entfernung aller Ihrer Daten aus unserem System.',
  restaurants: 'Restaurants',
  network: 'Netzwerk',
  stores: 'Shops',
  commandes: 'Bestellungen',
  applications: 'Anwendungen',
  inviteUsers: 'Benutzer einladen',
  inviteAgents: 'Agenten einladen',
  inviteStaff: 'Personal einladen',
  invitationsList: 'Einladungsliste',
  promotersTree: 'Einladungsbaum',
  promotionGroups: 'PromoBooster-Gruppen',
  onboarding: 'Einarbeitung',
  enhanced_organization: {
    address_requires_coordinates: 'Bitte wählen Sie eine gültige Adresse aus den Vorschlägen',

    // Step Labels
    step_labels: {
      basic: 'Grundlegende Informationen',
      contact: 'Kontaktinformationen',
      type: 'Organisationstyp',
      roles: 'Mitarbeiterrollen',
      staff: 'Teammitglieder',
      features: 'Funktionen & Einstellungen',
      availability: 'Verfügbarkeit & Öffnungszeiten',
      showcase: 'Musik-Showcase',
      quick_setup: 'Schnelleinrichtung',
    },

    // Dialog Title and General
    create_organization: 'Organisation erstellen',
    step: 'Schritt',
    of: 'von',
    quick_mode: 'Schnellmodus',
    quick_setup: 'Schnelleinrichtung',
    music_studio: 'Musikstudio',

    // Basic Information Step
    tell_us_about_organization: 'Erzählen Sie uns von Ihrer Organisation',
    basic_info_subtitle: 'Beginnen wir mit den grundlegenden Informationen',
    organization_name: 'Name der Organisation',
    organization_name_required: 'Name der Organisation *',
    organization_name_exists: 'Organisationsname existiert bereits',
    description: 'Beschreibung',
    description_required: 'Beschreibung *',
    language: 'Sprache',
    organization_logo: 'Organisationslogo',
    upload_logo: 'Logo hochladen',
    cover_image: 'Titelbild',
    upload_cover_image: 'Titelbild hochladen',
    change_logo: 'Logo ändern',

    // Quick Mode
    quick_setup_mode: 'Schnelleinrichtungsmodus',
    using_quick_setup:
      'Schnelleinrichtung mit Standardwerten – für detaillierte Konfiguration deaktivieren',
    skip_detailed_setup:
      'Überspringen Sie die detaillierte Einrichtung und verwenden Sie Standardwerte. Sie können alles später konfigurieren.',
    detailed_setup: 'Detaillierte Einrichtung',

    // Contact Information Step
    contact_information: 'Kontaktinformationen',
    contact_info_subtitle: 'Geben Sie die Kontaktdaten und Adresse Ihres Studios an',
    email_address: 'E-Mail-Adresse',
    main_contact_email: 'Hauptkontakt-E-Mail des Studios',
    phone_number: 'Telefonnummer',
    contact_phone_number: 'Kontakttelefonnummer',
    website: 'Website',
    studio_website_optional: 'Website Ihres Studios (optional)',
    studio_address: 'Studioadresse',
    full_address_location: 'Vollständige Adresse des Studios',
    location_verified: 'Standort verifiziert',
    no_locations_found: 'Keine Standorte gefunden',
    contact_info_help:
      'Kontaktinformationen helfen Kunden, Ihr Studio zu finden und zu erreichen. Sie können diese Daten später in den Einstellungen aktualisieren.',

    // Type Selection Step
    creating_music_studio: 'Musikstudio wird erstellt',
    creating_studio_subtitle:
      'Sie erstellen eine Aufnahme-Studiosorganisation mit erweiterten Funktionen',
    what_type_organization: 'Welcher Organisationstyp ist das?',
    type_selection_subtitle: 'Dies hilft uns, die Erfahrung für Sie anzupassen',
    existing: 'Bestehend',

    // Roles Setup Step
    set_up_staff_roles: 'Mitarbeiterrollen einrichten',
    roles_setup_subtitle:
      'Definieren Sie Rollen für Ihre Teammitglieder. Sie können diesen Schritt überspringen.',
    use_recommended_roles: 'Empfohlene Rollen für diesen Organisationstyp verwenden',
    recommended_roles: 'Empfohlene Rollen',
    custom_roles: 'Benutzerdefinierte Rollen',
    role_name: 'Rollenname',

    // Staff Setup Step
    add_team_members: 'Teammitglieder hinzufügen',
    staff_setup_subtitle:
      'Fügen Sie Ihre Teammitglieder hinzu. Sie können später weitere hinzufügen.',
    add_staff_member: 'Mitarbeiter hinzufügen',
    add_new_staff_member: 'Neuen Mitarbeiter hinzufügen',
    name: 'Name',
    name_required: 'Name *',
    email: 'E-Mail',
    email_required: 'E-Mail *',
    password: 'Passwort',
    leave_empty_default: 'Leer lassen für Standard (123)',
    role: 'Rolle',
    cancel: 'Abbrechen',
    add_member: 'Mitglied hinzufügen',
    added_staff_members: 'Hinzugefügte Mitarbeiter',
    custom_role: 'Benutzerdefinierte Rolle',

    // Availability Setup Step
    studio_availability: 'Studioverfügbarkeit',
    availability_subtitle:
      'Konfigurieren Sie Arbeitszeiten, Buchungszeiträume und Verfügbarkeitsregeln Ihres Studios',
    please_fix_issues: 'Bitte beheben Sie die folgenden Probleme:',
    working_hours: 'Arbeitszeiten',
    booking_rules: 'Buchungsregeln',
    time_slots: 'Zeitfenster',
    weekly_schedule: 'Wöchentlicher Zeitplan',
    weekly_schedule_subtitle:
      'Legen Sie die Öffnungszeiten Ihres Studios für jeden Wochentag fest. Aktivieren Sie den 24-Stunden-Modus oder erstellen Sie über Mitternacht gehende Zeitpläne (z. B. 22:00 bis 06:00 am nächsten Tag)',

    // Cross-Day Booking Policy
    cross_day_booking_policy: 'Über-Tages-Buchungsrichtlinie',
    enable_cross_day_bookings: 'Buchungen über Mitternacht zulassen',
    cross_day_help: 'Buchungen erlauben, die über Mitternacht gehen (z. B. 23:00 bis 2:00 Uhr)',
    max_cross_day_hours: 'Maximale Über-Tages-Stunden',
    max_cross_day_help: 'Maximale Dauer, die eine Buchung über Tage hinweg gehen kann',
    allow_weekend_crossover: 'Wochenendüberschneidung erlauben',
    weekend_crossover_help: 'Buchungen über Wochenende und Wochentage hinweg erlauben',
    require_same_day_start: 'Gleicher Tag erforderlich',
    same_day_start_help: 'Buchung muss am selben Kalendertag beginnen und enden',

    // Days of Week
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',

    // Time Configuration
    start_time: 'Startzeit',
    end_time: 'Endzeit',
    next_day: 'Nächster Tag',
    cross_midnight_schedule: 'Über-Mitternacht-Zeitplan:',

    // Booking Configuration
    booking_configuration: 'Buchungskonfiguration',
    booking_config_subtitle: 'Buchungsregeln und Einschränkungen konfigurieren',
    advance_booking_days: 'Vorausbuchungstage',
    advance_booking_help: 'Wie viele Tage im Voraus Kunden buchen können',
    minimum_notice_hours: 'Mindestankündigung (Stunden)',
    minimum_notice_help: 'Mindeststunden vor der Buchung',
    max_session_duration: 'Maximale Sitzungsdauer (Minuten)',
    max_duration_help: 'Maximale Buchungsdauer',
    buffer_time_minutes: 'Pufferzeit (Minuten)',
    buffer_time_help: 'Pause zwischen Buchungen',
    auto_approve_bookings: 'Buchungen automatisch genehmigen',
    auto_approve_help: 'Buchungsanfragen automatisch genehmigen, ohne manuelle Prüfung',
    allow_back_to_back: 'Rücken-an-Rücken-Buchungen zulassen',
    back_to_back_help: 'Erlaubt, dass Buchungen direkt aufeinander folgen',

    // Time Slot Configuration
    time_slot_configuration: 'Zeitfensterkonfiguration',
    time_slot_subtitle: 'Buchungszeitfenster und Intervalle konfigurieren',
    time_slot_unit: 'Zeiteinheit',
    default_slot_duration: 'Standardzeitfensterdauer (Minuten)',
    slot_duration_help: 'Standarddauer für Buchungszeitfenster',
    time_slot_help:
      'Zeitfenster werden basierend auf Ihren Arbeitszeiten und der gewählten Einheit generiert. Kunden können verfügbare Zeitfenster auswählen.',

    // Actions
    reset_to_defaults: 'Auf Standard zurücksetzen',
    current_settings_applied: 'Aktuelle Einstellungen werden nach der Einrichtung angewendet',
    availability_for_studios:
      'Verfügbarkeitseinstellungen sind hauptsächlich für Aufnahmestudios vorgesehen. Sie können diese später im Dashboard anpassen.',
    skip_configure_later:
      'Sie können diesen Schritt überspringen und die Verfügbarkeit später im Dashboard konfigurieren. Diese Einstellungen helfen, Ihren Buchungsprozess zu automatisieren.',

    // Showcase Setup Step
    music_showcase: 'Musik-Showcase',
    showcase_subtitle:
      'Richten Sie ein Musik-Showcase ein, um die Arbeiten Ihres Studios zu präsentieren',
    enable_music_showcase: 'Musik-Showcase aktivieren',
    showcase_enabled_help:
      'Wenn aktiviert, wird Ihr Musik-Showcase für Kunden auf Ihrem Profil sichtbar',
    showcase_title: 'Showcase-Titel',
    showcase_title_placeholder: 'z. B. Unsere neuesten Produktionen',
    showcase_description: 'Showcase-Beschreibung',
    showcase_description_placeholder: 'Beschreiben Sie Ihr Musik-Showcase...',
    add_music_tracks_later:
      'Sie können nach Abschluss der Einrichtung Musik von YouTube, Spotify, SoundCloud usw. hinzufügen.',
    showcase_for_studios:
      'Das Musik-Showcase ist speziell für Aufnahmestudios konzipiert. Dieser Schritt kann übersprungen werden.',
    configure_showcase_later:
      'Keine Sorge, Sie können Ihr Musik-Showcase später im Dashboard konfigurieren.',

    // Quick Setup Step
    quick_setup_title: 'Schnelleinrichtung',
    quick_setup_subtitle_studio:
      'Erstellen Sie Ihr Musikstudio mit minimalem Aufwand. Alles kann später angepasst werden.',
    quick_setup_subtitle_general:
      'Erstellen Sie Ihre Organisation mit minimalem Setup. Alles kann später angepasst werden.',
    contact_email: 'Kontakt-E-Mail',
    contact_phone: 'Kontakttelefon',
    logo: 'Logo',
    optional: 'Optional',
    studio_description_placeholder:
      'Beschreiben Sie Ihr Musikstudio, Ihre Spezialisierungen und Besonderheiten...',
    organization_description_placeholder:
      'Beschreiben Sie Ihre Organisation und Dienstleistungen...',

    // Default Settings Preview
    default_settings_applied: 'Standardwerte angewendet',
    standard_working_hours: 'Standardarbeitszeiten',
    basic_booking_settings: 'Einfache Buchungseinstellungen',
    default_roles: 'Standardrollen',
    core_features_enabled: 'Kernfunktionen aktiviert',
    standard_availability_settings: 'Standard-Verfügbarkeitseinstellungen',
    basic_notification_preferences: 'Einfache Benachrichtigungseinstellungen',
    customize_settings_later: 'Alle Einstellungen können später im Dashboard angepasst werden.',
    changed_your_mind: 'Anders überlegt?',
    switch_to_detailed:
      'Wechseln Sie zur detaillierten Einrichtung, um Rollen, Mitarbeiter, Funktionen und Verfügbarkeit Schritt für Schritt zu konfigurieren. Ihre Basisinformationen bleiben erhalten.',

    // Navigation
    back: 'Zurück',
    skip: 'Überspringen',
    next: 'Weiter',
    complete_setup: 'Einrichtung abschließen',

    // Validation Messages
    validation: {
      advance_booking_range: 'Vorausbuchungstage müssen zwischen 1 und 365 liegen',
      minimum_notice_positive: 'Mindestankündigung darf nicht negativ sein',
      max_duration_minimum: 'Maximale Buchungsdauer muss mindestens 15 Minuten betragen',
      slot_duration_minimum: 'Zeitfenster müssen mindestens 15 Minuten betragen',
      buffer_time_positive: 'Pufferzeit darf nicht negativ sein',
      reset_success: 'Verfügbarkeitseinstellungen auf Standard zurückgesetzt',
      fix_issues: 'Bitte beheben Sie die folgenden Probleme:',
      advance_booking_days: 'Vorausbuchungstage müssen positiv sein',
      minimum_notice_hours: 'Mindestankündigungsstunden müssen positiv sein',
      max_session_duration: 'Maximale Sitzungsdauer muss positiv sein',
      buffer_time_minutes: 'Pufferzeit muss positiv sein',
      default_slot_duration: 'Standardzeitfenster muss positiv sein',
    },

    // Completion Messages
    organization_created_success: 'Organisation erfolgreich erstellt!',
    create_organization_failed: 'Organisation konnte nicht erstellt werden',
    user_not_authenticated: 'Benutzer nicht authentifiziert',

    // Additional Translation Keys for Enhanced UI
    days: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
    },
    time_units: {
      fifteenMinutes: '15 Minuten',
      thirtyMinutes: '30 Minuten',
      oneHour: '1 Stunde',
    },
    placeholders: {
      contact_email: 'kontakt@studio.com',
      contact_phone: '+49 30 123456789',
    },
    alerts: {
      availability_reset: 'Verfügbarkeitseinstellungen auf Standard zurückgesetzt',
      studio_availability_note:
        'Verfügbarkeitseinstellungen sind hauptsächlich für Aufnahmestudios vorgesehen. Sie können diese später im Dashboard anpassen.',
      skip_availability_note:
        'Sie können diesen Schritt überspringen und die Verfügbarkeit später konfigurieren. Diese helfen, den Buchungsprozess zu automatisieren.',
    },

    availability: {
      cross_day_description:
        'Buchungen erlauben, die über Mitternacht gehen (z. B. 23:00 bis 2:00 Uhr)',
      max_cross_day_hours_help: 'Maximale Dauer, die eine Buchung über Tage hinweg gehen kann',
      weekend_crossover_help: 'Buchungen über Wochenende und Wochentage hinweg erlauben',
      same_day_start_help: 'Buchung muss am selben Tag beginnen und enden',
      next_day: 'Nächster Tag',
      cross_midnight_schedule: 'Über-Mitternacht-Zeitplan:',
      next_day_suffix: 'nächster Tag',
      advance_booking_help: 'Wie viele Tage im Voraus Kunden buchen können',
      min_notice_help: 'Mindeststunden vor der Buchung',
      max_duration_help: 'Maximale Buchungsdauer',
      buffer_time_help: 'Pause zwischen Buchungen',
      auto_approve_help: 'Buchungen automatisch genehmigen, ohne manuelle Prüfung',
      back_to_back_help: 'Direkt aufeinanderfolgende Buchungen erlauben',
      slot_duration_help: 'Standarddauer für Buchungszeitfenster',
      time_slots_explanation:
        'Zeitfenster werden auf Grundlage Ihrer Arbeitszeiten erstellt. Kunden wählen aus verfügbaren Slots.',
      settings_apply_note: 'Aktuelle Einstellungen werden nach der Einrichtung angewendet',
    },
    tabs: {
      working_hours: 'Arbeitszeiten',
      booking_rules: 'Buchungsregeln',
      time_slots: 'Zeitfenster',
    },
    sections: {
      weekly_schedule: 'Wöchentlicher Zeitplan',
      weekly_schedule_description:
        'Legen Sie die Öffnungszeiten Ihres Studios für jeden Tag fest. Aktivieren Sie den 24h-Modus oder erstellen Sie über Mitternacht gehende Pläne (z. B. 22:00–06:00).',
      cross_day_policy: 'Über-Tages-Buchungsrichtlinie',
      booking_configuration: 'Buchungskonfiguration',
      booking_configuration_description: 'Buchungsregeln und Einschränkungen konfigurieren',
      time_slot_configuration: 'Zeitfensterkonfiguration',
      time_slot_description: 'Buchungszeitfenster und Intervalle konfigurieren',
    },
    controls: {
      enable_cross_day: 'Über-Tages-Buchungen aktivieren',
      max_cross_day_hours: 'Maximale Über-Tages-Stunden',
      allow_weekend_crossover: 'Wochenendüberschneidung erlauben',
      require_same_day_start: 'Gleicher Tag erforderlich',
      twentyFourHours: '24 h',
      start_time: 'Startzeit',
      end_time: 'Endzeit',
      advance_booking_days: 'Vorausbuchungstage',
      minimum_notice_hours: 'Mindestankündigung (Stunden)',
      max_session_duration: 'Maximale Sitzungsdauer (Minuten)',
      buffer_time_minutes: 'Pufferzeit (Minuten)',
      auto_approve_bookings: 'Buchungen automatisch genehmigen',
      allow_back_to_back: 'Rücken-an-Rücken-Buchungen zulassen',
      time_slot_unit: 'Zeiteinheit',
      default_slot_duration: 'Standardzeitfensterdauer (Minuten)',
    },
    quick_setup_content: {
      studio_description:
        'Erstellen Sie ein professionelles Musikstudio-Profil mit den wichtigsten Funktionen und Einstellungen',
      org_description:
        'Erstellen Sie Ihre Organisation mit grundlegender Einrichtung und Basisfunktionen',
      organization_name_required: 'Name der Organisation *',
      description_required: 'Beschreibung *',
      studio_placeholder: 'Beschreiben Sie Ihr Studio, Dienstleistungen und Spezialisierungen...',
      org_placeholder: 'Beschreiben Sie die Dienstleistungen und Mission Ihrer Organisation...',
      optional: 'Optional',
      change_logo: 'Logo ändern',
      upload_logo: 'Logo hochladen',
      default_settings_applied: 'Standardwerte angewendet',
      detailed_setup: 'Detaillierte Einrichtung',
      standard_working_hours: 'Standardarbeitszeiten (9–18 Uhr, Montag–Freitag)',
      basic_booking_settings: 'Einfache Buchungseinstellungen mit 1-Stunden-Zeitfenstern',
      auto_approval: 'Automatische Genehmigung für einfacheren Buchungsprozess aktiviert',
      advance_booking: '7 Tage Vorausbuchungszeitraum',
      buffer_time: '30 Minuten Pufferzeit zwischen Sitzungen',
      customize_later_note: 'Alle Einstellungen können später im Dashboard angepasst werden.',
      changed_mind: 'Anders überlegt?',
      switch_to_detailed:
        'Wechseln Sie zur detaillierten Einrichtung, um volle Kontrolle über die Konfiguration Ihrer Organisation zu erhalten.',
    },
    showcase: {
      title: 'Musik-Showcase',
      description:
        'Präsentieren Sie Ihre musikalischen Arbeiten, Künstler und kreatives Portfolio, um Kunden zu gewinnen und Ihre Studiofähigkeiten zu demonstrieren',
      enable_showcase: 'Musik-Showcase aktivieren',
      visibility_note:
        'Erstellen Sie ein öffentliches Showcase auf der Profilseite Ihrer Organisation',
      title_placeholder: 'Mein Studio-Showcase',
      description_placeholder: 'Beschreiben Sie Ihr Musik-Showcase...',
      platform_integration_note:
        'Sie können später Musik von Spotify, SoundCloud und anderen Plattformen über die Showcase-Verwaltung hinzufügen.',
      studio_specific_note:
        'Musik-Showcases sind hauptsächlich für Aufnahmestudios und Musikveranstaltungsorte vorgesehen.',
      dashboard_config_note:
        'Sie können diesen Schritt überspringen und Ihr Showcase später im Dashboard konfigurieren.',
    },
    buttons: {
      reset_to_defaults: 'Auf Standard zurücksetzen',
    },
    roles: {
      custom_role: 'Benutzerdefinierte Rolle',
    },
  },
  if_mistake_contact_instadrink: 'Falls Sie einen Fehler haben, kontaktieren Sie bitte I.D',
  invitation_rejected: 'Einladung abgelehnt',
  invite_owner: 'Ich möchte einen Besitzer einladen',
  invite_referrer: 'Ich möchte einen PromoBooster einladen',
  invite_ambassador: 'Ich möchte einen Botschafter einladen',
  your_organisation_staff: 'Ihr Organisationspersonal',
  inv_org_desc: 'Der Organisator Ihres Events',
  inv_bnc_desc: 'Der Zugangskontrolleur Ihres Events',
  invite_more_staff: 'Mehr Personal einladen',
  since: 'Seit',
  delete_event_modal: 'Sind Sie sicher, dass Sie das Event löschen möchten',
  publish_event_modal: 'Sind Sie sicher, dass Sie das Event veröffentlichen möchten',
  cancel_event_modal: 'Sind Sie sicher, dass Sie das Event absagen möchten',
  archive_event_modal: 'Sind Sie sicher, dass Sie das Event archivieren möchten',
  duplicate_event: 'Event duplizieren',
  duplicate: 'Duplizieren',
  reservations: 'Reservierungen',
  multiple_persons: 'Mehrere Personen',
  persons_number: 'Anzahl der Personen',
  vatRate: 'Mehrwertsteuersatz',
  price_TTC: 'Preis inklusive Steuern',
  Occupation: 'Beruf',
  priceHt: 'Preis ohne Steuern',
  promobooster_mode: 'PromoBooster-Modus',
  promo_mode: 'Promo-Modus',
  Amount: 'Betrag',
  Percentage: 'Prozentsatz',
  include_owners: 'Besitzer einschließen',
  add_anonymous_promoter: 'SpyBooster hinzufügen',
  Confirm_Name: 'Namen bestätigen',
  Add_Anonymous_Name: 'SpyBooster hinzufügen',
  ask_for_invoice: 'Nach Rechnung fragen',
  add_invoice_button: 'Hinzufügen',
  enter_valid_invoice: 'Bitte geben Sie eine gültige Rechnung ein',
  Compan_Name_Last_Name: 'Firma/Name/Nachname',
  tva: 'MwSt',
  adresse: 'Adresse',
  postal_code: 'Postleitzahl',
  country: 'Land',
  additional_information: 'Zusätzliche Informationen',
  invoice_information: 'Rechnungsdaten',
  survey_information: 'Umfrageinformationen',
  know_from_invoice: 'Welche Informationen benötigen Sie von Ihrer Rechnung?',
  know_from_attendees: 'Was müssen Sie von Ihren Teilnehmern wissen?',
  add_invoice: 'Neues Feld hinzufügen',
  active_invoice: 'Rechnung aktivieren',
  actived_invoice: 'Die Rechnung ist aktiviert',
  preview_your_share: 'Vorschau der Verteilung',
  Number_of_event: 'Anzahl der Events',
  time_of_creation: 'Erstellt am',
  Owner_details: 'Besitzerdetails',
  greetings: 'Grüße,',
  you_have_been_invited: 'Sie wurden eingeladen, I.D beizutreten 🎉',
  plz_wait_a_moment: 'Bitte warten Sie einen Moment',
  thanks_time: 'Dankeszeit',
  averagePreparationTime: 'Durchschnittliche Zubereitungszeit',
  minutes: 'Minuten',
  seconds: 'Sekunden',
  select_menu: 'Menü auswählen',
  capacity_warning_message: 'Die Kapazitäten sind im Vergleich zur Gesamtkapazität erschöpft.',
  add_product_alert:
    'Um Produkte zu Ihren Tickets hinzuzufügen, verknüpfen Sie bitte einen Shop mit Ihrem Event',
  remaining_places: 'Verbleibende Plätze',
  navigate_to_event_menu: 'Zum Veranstaltungsmenü navigieren',
  you_have_no_store: 'Sie haben keinen Laden',
  reject_order: 'Bestellung ablehnen',
  add_Waiter: 'Kellner hinzufügen',
  add_room: 'Raum hinzufügen',
  room_name: 'Raumname',
  campaigns: {
    title: 'E-Mail-Kampagnen',
    audience: 'Zielgruppe',
    segment: 'Segment',
    createNew: 'Neue Kampagne erstellen',
    name: 'Name',
    template: 'Vorlage',
    scheduledTime: 'Geplante Zeit',
    status: 'Status',
    actions: 'Aktionen',
    backToList: 'Zurück zur Kampagnenliste',
    info: 'Kampagneninformationen',
    mails: 'E-Mails',
    email: 'E-Mail',
    emailStatus: 'E-Mail-Status',
    confirmDeletion: 'Löschen bestätigen',
    deleteConfirmationMessage:
      'Sind Sie sicher, dass Sie diese E-Mail-Kampagne löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Kampagne bearbeiten',
    create: 'Neue Kampagne erstellen',
    campaignName: 'Kampagnenname',
    save: 'Speichern',
    selectTemplate: 'Vorlage auswählen',
    createNewTemplate: 'Neue Vorlage erstellen',
    audienceType: {
      title: 'Zielgruppe',
      all: 'Alle Kontakte',
      segment: 'Spezifisches Segment',
      eventBuyers: 'Event-Ticketkäufer',
    },
    emailstatus: {
      'email.sent': 'Gesendet',
      'email.delivered': 'Zugestellt',
      'email.delivery_delayed': 'Zustellung Verzögert',
      'email.complained': 'Beschwerde Eingegangen',
      'email.bounced': 'Zurückgewiesen',
      'email.opened': 'Geöffnet',
      'email.clicked': 'Angeklickt',
      'email.unsubscribed': 'Abgemeldet',
      'email.failed': 'Versand Fehlgeschlagen',
      'email.blocked': 'Blockiert',
      'email.dropped': 'Verworfen',
      'email.deferred': 'Verzögert',
      'email.rejected': 'Abgelehnt',
    },
    drawer: {
      create: 'Kampagne Erstellen',
      edit: 'Kampagne Bearbeiten',
      name: 'Kampagnenname',
      audienceType: 'Zielgruppentyp',
      segment: 'Segment Auswählen',
      draftInfo: 'Kampagne wird als Entwurf gespeichert',
    },
    stats: {
      title: 'Kampagnenstatistiken',
      delivered: 'Zugestellt',
      opened: 'Geöffnet',
      clicked: 'Geklickt',
      bounced: 'Zurückgewiesen',
    },
    campaignStatus: {
      pending: 'Ausstehend',
      scheduled: 'Geplant',
      sending: 'Wird gesendet',
      launched: 'Gesendet',
      failed: 'Fehlgeschlagen',
      'template-ready': 'Vorlage bereit',
      draft: 'Entwurf',
    },
    subject: 'E-Mail-Betreff',
    subjectHelperText: 'Sie können den Vorlagenbetreff für diese Kampagne anpassen',
    launchType: {
      title: 'Starttyp',
      immediate: 'Sofort starten',
      scheduled: 'Später planen',
    },
    schedule: {
      action: 'Planen',
      send: 'Senden',
      title: 'Kampagne Planen',
      info: 'Versand planen für Kampagne: {{name}}',
      scheduledTimeHelper:
        'Wählen Sie ein zukünftiges Datum und Uhrzeit für den Versand Ihrer Kampagne',
      errors: {
        scheduleTimeRequired: 'Bitte wählen Sie eine Planungszeit',
        testEmailRequired: 'Bitte geben Sie eine Test-E-Mail-Adresse ein',
        scheduleFailed: 'Kampagnenplanung fehlgeschlagen',
        testSendFailed: 'Fehler beim Senden der Test-E-Mail',
      },
      success: {
        testSent: 'Test-E-Mail erfolgreich gesendet',
        launched: 'Kampagne erfolgreich gestartet',
        scheduled: 'Kampagne erfolgreich geplant',
      },
    },
  },
  Include_Platform_Fees: 'Plattformgebühren einschließen',
  Final_Price: 'Endpreis',
  Platform_Fee_Info:
    'Wenn aktiviert, wird die Plattformgebühr von 2,5% zum Ticketpreis hinzugefügt und von den Teilnehmern bezahlt. Wenn deaktiviert, wird diese Gebühr von Ihren Ticketeinnahmen abgezogen.',
  Cost_to_buyers: 'Kosten für den Kunde',
  contacts: {
    totalContacts: '{{count}} Kontakte',
    import: 'Kontakte importieren',
    export: 'Als CSV exportieren',
    deleteSelected: 'Ausgewählte löschen',
    search: 'Suchen',
    noContactsToExport: 'Keine Kontakte zum Exportieren.',
    errorDeletingContacts: 'Fehler beim Löschen der Kontakte',
    errorLoadingContacts: 'Fehler beim Laden der Kontakte',
    confirmDeletion: 'Löschen bestätigen',
    confirmDeletionMessage:
      'Sind Sie sicher, dass Sie die {count} ausgewählten Kontakte löschen möchten?',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    dragAndDropInstruction:
      'Ziehen Sie eine CSV- oder XLSX-Datei hierher oder klicken Sie zum Auswählen',
    file: 'Datei: {name}',
    removeFile: 'Datei entfernen',
    informationMapping: 'Informationszuordnung',
    select: 'Auswählen',
    additionalFields: 'Zusätzliche Felder',
    errorParsingFile: 'Fehler beim Analysieren der Datei. Bitte versuchen Sie es erneut.',
    contactsImportedSuccessfully: 'Kontakte erfolgreich importiert',
    errorImportingContacts: 'Fehler beim Importieren der Kontakte. Bitte versuchen Sie es erneut.',
    fields: {
      email: 'E-Mail',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      age: 'Alter',
      gender: 'Geschlecht',
      country: 'Land',
      zone: 'Zone',
      postalCode: 'Postleitzahl',
    },
  },
  no_confirmed_tickets_to_export: 'Keine bestätigten Tickets zum Exportieren',
  export_confirmed_ticket_ids_tooltip: 'Bestätigte Ticket-IDs exportieren',
  loading: 'Wird geladen...',
  export_confirmed_tickets: 'Bestätigte Tickets exportieren ({{count}})',
  check_invitation_list: 'Kontaktliste prüfen',
  segments: {
    create: {
      title: 'Neues Segment erstellen',
      selectType: 'Wählen Sie einen Segmenttyp',
      dynamicSegment: {
        title: 'Dynamisches Filtersegment',
        description:
          'Wenden Sie eine Liste von Attributen an, um einen Teil Ihrer Kontakte auszuwählen. Ihre Kontakte werden basierend auf den gewählten Filtern automatisch zu diesem Segment hinzugefügt oder daraus entfernt.',
      },
      manualSegment: {
        title: 'Manuelles Segment über CSV',
        description:
          'Sie können eine Liste von Kontakten aus einer CSV-Datei importieren, um sie in einem Segment zu gruppieren. Sie können diese Funktion verwenden, um bestehende Kontakte als neues Segment erneut zu importieren.',
      },
      step: 'Schritt',
      of: 'von',
      removeFile: 'Datei entfernen',
      newsletterContacts: '{{count}} / 2000 Newsletter-Abonnenten bereits importiert.',
      selectAgeRange: 'Wählen Sie den Altersbereich aus, den Sie filtern möchten:',
      averageAge: 'Durchschnitt: {{age}} Jahre',
      infoKnownFor: 'Diese Information ist für {{count}} Kontakte bekannt',
      selectCountries: 'Ein oder mehrere Länder auswählen',
      selectZones: 'Zonen auswählen',
      addPostalCodes: 'Postleitzahlen hinzufügen (durch Komma getrennt)',
      selectLanguage: 'Sprache auswählen',
      whenAdded: 'Wann dieser Kontakt zu Ihrer Community hinzugefügt wurde',
      contactsImported: 'Kontakte, die bereits für Ihren Newsletter importiert wurden.',
      dropFileHere: 'Legen Sie Ihre CSV-, XLS- oder XLSX-Datei hier ab',
      fileRequirements:
        'Ihre Datei muss mindestens eine Spalte mit der E-Mail-Adresse der Kontakte enthalten. Um ihnen Newsletter zu senden, muss sie eine Spalte für das Newsletter-Abonnement (ja/nein) haben.',
      removeFilters: 'Filter entfernen',
      contactInformation: 'KONTAKTINFORMATIONEN',
      marketing: 'MARKETING',
      history: 'VERLAUF',
      fieldMapping: 'Feldzuordnung',
      additionalFields: 'Zusätzliche Felder',
      segmentName: 'Segmentname',
      description: 'Beschreibung',
      matchingContacts: 'passende Kontakte',
      back: 'Zurück',
      cancel: 'Abbrechen',
      next: 'Weiter',
      createSegment: 'Segment erstellen',
      importContacts: 'Kontakte als Segment importieren',
    },
    fieldsMapping: {
      name: 'Name',
      email: 'E-Mail',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      age: 'Alter',
      gender: 'Geschlecht',
      country: 'Land',
      zone: 'Zone',
      postalCode: 'Postleitzahl',
    },
    filters: {
      activeFilters: 'Aktive Filter',
      hasEmail: 'Hat eine E-Mail',
      emailVerified: 'E-Mail verifiziert',
      hasPhone: 'Hat eine Telefonnummer',
      age: 'Alter',
      gender: 'Geschlecht',
      location: 'Standort',
      language: 'Sprache',
      dateAdded: 'Hinzugefügt am',
      selectCountries: 'Wählen Sie ein oder mehrere Länder',
      selectZones: 'Zonen auswählen',
      postalCodes: 'Postleitzahlen hinzufügen (durch Kommas getrennt)',
      selectLanguage: 'Sprache auswählen',
      allTime: 'Alle Zeit',
      today: 'Heute',
      yesterday: 'Gestern',
      last7days: 'Letzte 7 Tage',
      last14days: 'Letzte 14 Tage',
      last30days: 'Letzte 30 Tage',
      last90days: 'Letzte 90 Tage',
      customDates: 'Benutzerdefinierte Daten',
      from: 'Von',
      to: 'Bis',
      events: {
        title: 'Event-Teilnahme',
        hasAttendedEvents: 'Besuchte Events',
        attendanceInfo: 'Hat {{count}} oder mehr Events besucht',
        selectRange: 'Wählen Sie die Mindestanzahl besuchter Events',
        infoTooltip:
          'Dies wird Benutzer anzeigen, die mindestens diese Anzahl von Events besucht haben',
      },
    },
  },
  segment: {
    Create: {
      matchingContacts: 'übereinstimmende Kontakte',
      back: 'Zurück',
      cancel: 'Abbrechen',
      next: 'Weiter',
      importContacts: 'Kontakte importieren',
      title: 'Segment erstellen',
    },
  },
  stripe_connect: {
    setup_stripe_account: 'Stripe-Konto einrichten',
    complete_stripe_setup: 'Einrichtung abschließen',
    alert_stripe_incomplete_setup:
      'Die Einrichtung Ihres Stripe-Kontos ist unvollständig. Bitte schließen Sie den Verifizierungsprozess ab, um Zahlungen für Ihre Veranstaltungen zu erhalten.',
    error_creating_stripe_account:
      'Fehler beim Erstellen des Stripe-Kontos. Bitte versuchen Sie es später erneut.',
    error_creating_stripe_link:
      'Fehler beim Generieren des Stripe-Einrichtungslinks. Bitte versuchen Sie es später erneut.',
    legal_verification: 'Rechtliche Überprüfung erforderlich',
    alert_stripe_configuration_title:
      'Um Zahlungen für Ihre Veranstaltungen zu erhalten, müssen Sie Ihr Stripe Connect-Konto einrichten. Dieser Schritt ist für die rechtliche Konformität und sichere Zahlungsabwicklung erforderlich.',
  },
  templates: {
    createNew: 'Neue Vorlage erstellen',
    subject: 'E-Mail-Betreff',
    subjectRequired: 'E-Mail-Betreff ist erforderlich',
    createSuccess: 'Vorlage erfolgreich erstellt',
    createError: 'Fehler beim Erstellen der Vorlage',
  },
  survey: {
    title: 'Event-Umfrage-Editor',
    enable: 'Umfrage aktivieren',
    noResponses: 'Noch keine Antworten',
    totalResponses: 'Gesamtantworten: {{count}}',
    noSurveyData: 'Keine Umfragedaten verfügbar',
    errorLoading: 'Fehler beim Laden der Umfragedaten',
    question: {
      title: 'Frage {{number}}',
      required: 'Erforderlich',
      text: 'Fragentext',
      type: 'Fragetyp',
      types: {
        shortText: 'Kurzer Text',
        longText: 'Langer Text',
        radio: 'Optionsfelder',
        checkbox: 'Kontrollkästchen',
      },
      options: 'Optionen:',
      addOption: 'Option hinzufügen',
      submit: 'Frage speichern',
      validation: {
        emptyText: 'Der Fragentext darf nicht leer sein.',
        radioOptions: 'Die Einzelauswahlfrage muss mindestens eine Option haben.',
        checkboxOptions: 'Die Mehrfachauswahlfrage muss mindestens eine Option haben.',
      },
    },
    addQuestion: 'Frage hinzufügen',
    answersSummary: 'Antwortenzusammenfassung',
  },
  promoboosters: {
    referral_sales: 'Empfehlungsverkäufe',
    other_sales: 'Andere Verkäufe',
    available: 'Verfügbar',
    No_tickets_sold_yet: 'Noch keine Tickets verkauft',
    ticket_category: 'Ticketkategorie',
    total_sold: 'Gesamt Verkauft',
    initial_quantity: 'Anfangsmenge',
  },
  guests: {
    guestLists: 'Gästelisten',
    addList: 'Liste hinzufügen',
    addGuest: 'Gast hinzufügen',
    searchGuests: 'Gäste suchen',
    addNewList: 'Neue Liste hinzufügen',
    listName: 'Listenname',
    guestList: 'Gästeliste',
    sendEmailsToNewGuests: 'E-Mails an neue Gäste senden',
    single: 'Einzeln',
    import: 'Importieren',
    text: 'Text',
    name: 'Name',
    email: 'E-Mail',
    totalTickets: 'Gesamttickets',
    freeTickets: 'Freie Tickets',
    dragDropCsv: 'CSV-Datei hier ablegen oder zum Auswählen klicken',
    guestDetailsPlaceholder:
      'Gästedetails eingeben (eine pro Zeile): Name, GesamtTickets+FreieTickets, E-Mail',
    importGuests: 'Gäste importieren',
    editGuest: 'Gast bearbeiten',
    update: 'Aktualisieren',
    delete: 'Löschen',
    confirmDelete: 'Löschen bestätigen',
    confirmDeleteMessage:
      'Sind Sie sicher, dass Sie diesen Gast löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    cancel: 'Abbrechen',
    mapColumns: 'Spalten zuordnen',
    emailLabel: 'E-Mail',
    ticketsInfo: 'Tickets',
    csvImportInstructions:
      'Laden Sie eine CSV- oder Excel-Datei mit den Gästeinformationen hoch. Die Datei muss die folgenden Spalten enthalten:',
    csvRequiredColumns: 'Erforderliche Spalten',
    nameColumnDescription: 'Vollständiger Name des Gastes (erforderlich)',
    emailColumnDescription: 'E-Mail-Adresse des Gastes (optional)',
    totalTicketsColumnDescription: 'Gesamtzahl der zugewiesenen Tickets (mindestens 1)',
    freeTicketsColumnDescription:
      'Anzahl der kostenlosen Tickets (muss kleiner oder gleich der Gesamtanzahl sein)',
  },
  confirm_refund: 'Rückerstattung bestätigen',
  refund_confirmation_message:
    'Sind Sie sicher, dass Sie dieses Ticket zurückerstatten möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  refund_amount: 'Rückerstattungsbetrag',
  processing: 'Verarbeitung...',
  only_confirmed_tickets_can_be_refunded: 'Nur bestätigte Tickets können erstattet werden',
  refund_ticket: 'Ticket erstatten',
  send_confirmation_email: 'Best&auml;tigungs-E-Mail senden',
  can_only_send_email_for_confirmed_or_validated:
    'Kann nur E-Mails f&uuml;r best&auml;tigte oder validierte Tickets senden',
  deduct_platform_fee: 'Plattformgebühr Abziehen',
  platform_fee_toggle_description:
    'Wenn aktiviert, wird die Plattformgebühr vom Erstattungsbetrag abgezogen',
  'Remove Deformation': 'Remove Deformation',
  original_price: 'Originalpreis',
  platform_fee: 'Plattformgebühr',
  platform_fee_deduction: 'Abzug der Plattformgebühr',
  final_refund_amount: 'Endgültiger Erstattungsbetrag',
  'Deformed Price': 'Deformed Price',
  'Final Price': 'Final Price',
  'No deformations available': 'No price deformations available',
  'Price deformation added': 'Price deformation added successfully',
  'Price deformation removed': 'Price deformation removed',
  'Price Deformations Management': 'Price Deformations Management',
  'Add Price Deformation': 'Add Price Deformation',
  'No price deformations defined yet': 'No price deformations defined yet',
  Inactive: 'Inactive',
  off: 'off',
  Priority: 'Priority',
  Domains: 'Domains',
  'Are you sure you want to delete this price deformation?':
    'Are you sure you want to delete this price deformation?',
  'Price deformation deleted successfully': 'Price deformation deleted successfully',
  'Failed to delete price deformation': 'Failed to delete price deformation',
  'Ticket Restrictions': 'Ticket Restrictions',
  'Add Access Restriction': 'Add Access Restriction',
  'Access Restriction': 'Access Restriction',
  'Allowed Domains': 'Allowed Domains',
  'Restriction Rules': 'Restriction Rules',
  'A ticket can have either multiple price deformations OR one access restriction, but not both.':
    'A ticket can have either multiple price deformations OR one access restriction, but not both.',
  'Adding an access restriction will remove all price deformations. Continue?':
    'Adding an access restriction will remove all price deformations. Continue?',
  Access_Restriction_Description:
    'Der Zugang zu Tickets kann anhand Ihrer E-Mail-Domäne eingeschränkt sein.',
  total_tickets_sold: 'Gesamttickets verkauft',
  total_revenue: 'Gesamtumsatz',
  eventTicketStatistics: 'Ticketstatistiken der Veranstaltung',
  eventCapacity: 'Veranstaltungskapazität',
  totalTickets: 'Gesamtanzahl Tickets',
  totalReservations: 'Gesamtanzahl Reservierungen',
  ticketName: 'Ticketname',
  initialQuantity: 'Anfängliche Menge',
  soldQuantity: 'Verkaufte Menge',
  noTicketData: 'Keine Ticketdaten verfügbar',
  errorLoadingTickets: 'Fehler beim Laden der Ticketdaten',
  na: 'N/V',
  confirm_send_email: 'E-Mail-Versand bestätigen',
  send_email_confirmation_message:
    'Sind Sie sicher, dass Sie die Bestätigungs-E-Mail an diesen Empfänger senden möchten?',
  recipient: 'Empfänger',
  sending: 'Wird gesendet...',
  send: 'Senden',
  ticketInvitation: {
    import: {
      csvMode: 'CSV-Import',
      singleMode: 'Einzelimport',
      missingFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
      invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      'success.single': 'Einladung erfolgreich versendet',
      sendInvitation: 'Einladung senden',
      numTickets: 'Anzahl der Tickets',
      steps: {
        setup: 'Einrichtung',
        preview: 'Vorschau & Import',
      },
      next: 'Weiter',
      back: 'Zurück',
      summary: 'Import-Zusammenfassung',
      totalRecords: 'Gesamtanzahl der Datensätze',
      selectedTicket: 'Ausgewählte Ticket-Kategorie',
      title: 'Einladungen importieren',
      progress:
        'Verarbeite {{current}}/{{total}} ({{success}} erfolgreich, {{failed}} fehlgeschlagen)',
      dragOrSelect: 'CSV-Datei hier ablegen oder klicken zum Auswählen',
      dropHere: 'CSV-Datei hier ablegen',
      mapColumns: 'CSV-Spalten zuordnen',
      previewTitle: 'Vorschau',
      records: 'Einträge',
      firstThreeRecords: 'Erste drei Einträge',
      importButton: '{{count}} Einladungen importieren',
      errors: {
        unknown: 'Ein unbekannter Fehler ist aufgetreten',
        csvEmpty: 'Die CSV-Datei ist leer',
        invalidFormat: 'Ungültiges CSV-Format',
        parseError: 'Fehler beim Analysieren der CSV-Datei',
        fileTooLarge: 'Datei zu groß (max 5MB)',
        invalidFileType: 'Nur CSV-Dateien sind erlaubt',
        invalidDataRows: '{{count}} Zeilen enthalten ungültige Daten',
        missingMapping: 'Bitte ordnen Sie alle erforderlichen Spalten zu',
        creationFailed: 'Fehler beim Erstellen der Einladungen',
      },
      success: {
        partial:
          'Import abgeschlossen: {{success}} erfolgreich, {{failed}} fehlgeschlagen.\nDetails:\n{{details}}',
        complete: '{{count}} Einladungen erfolgreich erstellt',
      },
      explanation: {
        main: 'Importieren Sie Tickets für mehrere Teilnehmer über eine CSV-Datei. Perfekt für die Migration von anderen Ticketsystemen oder die Erstellung von Tickets für eine vordefinierte Gästeliste.',
        features: 'Dieses Import-Tool wird:',
        feature1: 'Digitale Tickets mit einzigartigen QR-Codes für jeden Teilnehmer erstellen',
        feature2: 'Bestätigungs-E-Mails mit Ticket-QR-Codes an die Teilnehmer senden',
        feature3:
          'Ihnen ermöglichen, spezifische Ticket-Kategorien allen importierten Gästen zuzuweisen',
      },
    },
  },
  tickets: {
    price_per_ticket_ht: 'pro Ticket zzgl. MwSt',
    hide_description: 'Ticket ausblenden (nur auf geheimer Seite sichtbar)',
    validation: {
      titleRequired: 'Titel ist erforderlich',
      descriptionRequired: 'Beschreibung ist erforderlich',
      priceZero: 'Der Preis kann nicht null sein',
      priceRequired: 'Preis ist erforderlich',
      initialQuantityZero: 'Anfangsmenge kann nicht null sein',
      maxQuantityLimit: 'Maximalmenge muss kleiner als Anfangsmenge sein',
      maxQuantityZero: 'Maximalmenge kann nicht null sein',
      minQuantityLimit: 'Mindestmenge muss kleiner als Maximalmenge und Anfangsmenge sein',
      minQuantityZero: 'Mindestmenge kann nicht null sein',
      categoryRequired: 'Kategorie ist erforderlich',
      productRequired: 'Produkt ist erforderlich',
      quantityRequired: 'Menge ist erforderlich',
      quantityGreaterThanZero: 'Menge muss größer als null sein',
      withProductRequired: 'Produkt ist erforderlich wenn iscomposite wahr ist',
      fieldRequired: 'Dieses Feld ist erforderlich',
      vatRateRange: 'Der Mehrwertsteuersatz muss zwischen 1 und 100 liegen',
    },
  },
  accessRequests: {
    request_access: 'Zugang Anfordern',
    request_access_title: 'Admin-Zugang Anfordern',
    full_name: 'Vollständiger Name',
    email: 'E-Mail',
    company_name: 'Firmenname',
    position: 'Position',
    reason: 'Warum benötigen Sie Zugang?',
    cancel: 'Abbrechen',
    submit: 'Anfrage Senden',
    submitting: 'Wird gesendet...',
    please_fill_all_fields: 'Bitte füllen Sie alle erforderlichen Felder aus',
    invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    error_submitting_request: 'Fehler beim Senden der Anfrage. Bitte versuchen Sie es erneut.',
    phone: 'Telefonnummer',
    phone_optional: 'Optional - Ländervorwahl eingeben',
    company_optional: 'Optional',
    position_optional: 'Optional',
    source: 'Wie haben Sie uns gefunden?',
    invalid_phone: 'Bitte geben Sie eine gültige Telefonnummer ein',
    source_options: {
      search_engine: 'Suchmaschine (Google, Bing, etc.)',
      social_media: 'Soziale Medien',
      friend: 'Freund oder Kollege',
      advertisement: 'Werbung',
    },
  },
  single_ticket: 'Ticket',
  price_deformation: {
    name_required: 'Name ist erforderlich',
    deformation_type_required: 'Deformationstyp ist erforderlich',
    value_required: 'Wert ist erforderlich',
    value_positive: 'Der Wert muss positiv sein',
    invalid_value: 'Ungültiger Wert',
    domain_required: 'Mindestens eine Domain ist erforderlich',
    edit_price: 'Preisdeformation bearbeiten',
    new_price: 'Neue Preisdeformation',
    edit_access: 'Zugangsbeschränkung bearbeiten',
    new_access: 'Neue Zugangsbeschränkung',
    name: 'Name',
    description: 'Beschreibung',
    active: 'Aktiv',
    deformation_type: 'Deformationstyp',
    percentage: 'Prozentsatz',
    fixed_amount: 'Fester Betrag',
    deformation_value: 'Deformationswert',
    email_domains: 'E-Mail-Domains',
    add_domain: 'Domain hinzufügen',
    priority: 'Priorität',
    cancel: 'Abbrechen',
    update: 'Aktualisieren',
    create: 'Erstellen',
    priority_info:
      'A prioridade determina a ordem em que as restrições são aplicadas. Restrições com prioridade mais alta (número maior) são verificadas primeiro. Por exemplo, uma restrição com prioridade 2 será verificada antes da prioridade 1.',
    other: 'Andere',
    condition_type: 'Beschränkungstyp',
    email_domain_type: 'E-Mail-Domain',
    email_address_type: 'E-Mail-Adresse',
    email_addresses: 'E-Mail-Adressen',
    add_email: 'E-Mail hinzufügen',
    import_csv: 'Aus CSV importieren',
    email_required: 'Mindestens eine E-Mail-Adresse ist erforderlich',
    emails_count: '{{count}} E-Mail-Adressen hinzugefügt',
    max_tickets_per_email: 'Maximale Tickets pro E-Mail',
    max_tickets_placeholder: 'Leer lassen für unbegrenzt',
    max_tickets_helper:
      'Begrenzen Sie, wie viele Tickets ein Kunde mit derselben E-Mail kaufen kann',
    max_tickets_info:
      'Festlegen, um die Anzahl der Tickets zu begrenzen, die mit einer einzelnen E-Mail-Adresse gekauft werden können. Leer lassen für keine Begrenzung.',
    min_tickets_value: 'Mindestwert ist 1',
    integer_tickets_value: 'Bitte geben Sie eine ganze Zahl ein',
    large_email_list_info:
      'Wenn Sie eine große Liste von E-Mail-Adressen haben, können Sie sie in einer CSV-Datei formatieren und hier hochladen. Die Datei muss eine Spalte mit den E-Mail-Adressen enthalten.',
    showing_preview: 'Mostrando vista previa de la {{count}} plantilla de correo',
  },
  Service_Fees: 'Servicegebühren',
  Per_Ticket: 'pro Ticket',
  event_sales_status: 'Verkaufsstatus der Veranstaltung',
  event_closed_for_sales: 'Diese Veranstaltung ist derzeit für den Verkauf geschlossen',
  event_open_for_sales: 'Diese Veranstaltung ist für den Verkauf geöffnet',
  open_sales: 'Verkauf öffnen',
  close_sales: 'Verkauf schließen',
  confirm_open_sales: 'Öffnung des Verkaufs bestätigen',
  confirm_close_sales: 'Schließung des Verkaufs bestätigen',
  open_sales_confirmation_message:
    'Sind Sie sicher, dass Sie den Verkauf für diese Veranstaltung öffnen möchten? Dies ermöglicht Benutzern neue Reservierungen.',
  close_sales_confirmation_message:
    'Sind Sie sicher, dass Sie den Verkauf für diese Veranstaltung schließen möchten? Dies verhindert neue Reservierungen von Benutzern.',
  event_closed_warning:
    'Der Verkauf ist derzeit für diese Veranstaltung geschlossen. Neue Reservierungen können erst nach Wiedereröffnung des Verkaufs vorgenommen werden.',
  Edit_Messages: 'Nachrichten bearbeiten',
  Email_Preview: 'E-Mail-Vorschau',
  multiple_tickets: 'Tickets',
  access_restrictions: 'Zugangsbeschränkungen',
  hidden_links: 'Versteckte Links',
  tickets_count: 'Anzahl der Tickets',
  access_restriction_description: 'Verwalten Sie, welche Personen Zugang haben sollen',
  add_access_restriction: 'Zugangsbeschränkung hinzufügen',
  inactive: 'Inaktiv',
  priority: 'Priorität',
  allowed_domains: 'E-Mail-Domains',
  delete_confirmation: 'Sind Sie sicher, dass Sie diese Zugangsbeschränkung löschen wollen?',
  stop_sell_time: 'Verkaufsstopp ist um',
  drag_drop_instruction: 'Ziehen und ablegen, um Tickets neu anzuordnen',
  create_tickets: 'Erstellen Sie Tickets für Ihre Veranstaltung',
  access_restriction_title: 'Zugangsbeschränkung',

  Language: 'Sprache',
  Error_loading_email_template: 'Fehler beim Laden der E-Mail-Vorlage',
  No_email_template_found: 'Keine E-Mail-Vorlage gefunden',
  No_preview_available: 'Keine Vorschau verfügbar',
  Edit_success: 'Bearbeitung erfolgreich!',
  Edit_failed: 'Bearbeitung fehlgeschlagen!',
  Loading: 'Wird geladen...',
  'Domain-based': 'Domain-basiert',
  'Email-based': 'E-Mail-basiert',
  'Allowed Values': 'Erlaubte Werte',
  Total: 'Gesamt',
  'email addresses': 'E-Mail-Adressen',
  'Access restrictions limit ticket purchases to specific email domains or addresses. Multiple restrictions can be active at the same time.':
    'Zugangsbeschränkungen begrenzen den Ticketkauf auf bestimmte E-Mail-Domains oder -Adressen. Mehrere Beschränkungen können gleichzeitig aktiv sein.',
  'Access restrictions limit ticket purchases to specific email domains or addresses. Only one restriction can be active at a time.':
    'Zugangsbeschränkungen begrenzen den Ticketkauf auf bestimmte E-Mail-Domains oder -Adressen. Es kann nur eine Beschränkung gleichzeitig aktiv sein.',
  'Allowed Emails': 'Erlaubte E-Mails',
  more: 'mehr',
  'No access restrictions have been created yet. Create one to limit ticket purchases to specific email domains or addresses.':
    'Es wurden noch keine Zugangsbeschränkungen erstellt. Erstellen Sie eine, um den Ticketkauf auf bestimmte E-Mail-Domains oder -Adressen zu beschränken.',
  'Are you sure you want to delete this access restriction?':
    'Sind Sie sicher, dass Sie diese Zugangsbeschränkung löschen möchten?',
  'Successfully added': 'Erfolgreich hinzugefügt',
  'Successfully updated': 'Erfolgreich aktualisiert',
  // German translations
  bus: {
    title: 'Busverwaltung',
    newTrip: 'Neue Busfahrt',
    active: 'Aktiv',
    past: 'Vergangen',
    all: 'Alle',
    name: 'Name',
    description: 'Beschreibung',
    route: 'Route',
    departureLocation: 'Abfahrtsort',
    arrivalLocation: 'Ankunftsort',
    duration: 'Dauer',
    minutes: 'Minuten',
    capacity: 'Kapazität',
    price: 'Preis',
    currency: 'Währung',
    isRoundTrip: 'Hin- und Rückfahrt',
    schedules: 'Fahrpläne',
    noTripsFound: 'Keine Busfahrten gefunden',
    noSchedulesFound: 'Keine Fahrpläne für diese Fahrt gefunden',
    actions: 'Aktionen',
    addSchedule: 'Fahrplan hinzufügen',
    edit: 'Fahrt bearbeiten',
    delete: 'Fahrt löschen',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Busfahrt löschen möchten?',
    confirmDeleteSchedule: 'Sind Sie sicher, dass Sie diesen Fahrplan löschen möchten?',
    departureDate: 'Abfahrtsdatum',
    departureTime: 'Abfahrtszeit',
    returnDate: 'Rückkehrdatum',
    returnTime: 'Rückkehrzeit',
    availableSeats: 'Verfügbare Plätze',
    status: 'Status',
    createSuccess: 'Busfahrt erfolgreich erstellt',
    createError: 'Fehler beim Erstellen der Busfahrt',
    updateSuccess: 'Busfahrt erfolgreich aktualisiert',
    updateError: 'Fehler beim Aktualisieren der Busfahrt',
    deleteSuccess: 'Busfahrt erfolgreich gelöscht',
    deleteError: 'Fehler beim Löschen der Busfahrt',
    scheduleAddSuccess: 'Fahrplan erfolgreich hinzugefügt',
    scheduleAddError: 'Fehler beim Hinzufügen des Fahrplans',
    scheduleDeleteSuccess: 'Fahrplan erfolgreich gelöscht',
    scheduleDeleteError: 'Fehler beim Löschen des Fahrplans',
    fetchError: 'Fehler beim Abrufen der Busfahrten',
    import: 'Fahrten importieren',
    importing: 'Busfahrten werden importiert',
    importSuccess: 'Busfahrten erfolgreich importiert',
    importError: 'Fehler beim Importieren von Busfahrten',
    parseError: 'Fehler beim Parsen der JSON-Datei',
    readError: 'Fehler beim Lesen der Datei',
    invalidFileType: 'Ungültiger Dateityp. Bitte wählen Sie eine JSON-Datei',
    importBusTrips: 'Busfahrten importieren',
    previewImport: 'Importvorschau',
    foundTrips: '{count} Fahrten in der Datei gefunden',
    details: 'Details',
    roundTrip: 'Hin- und Rückfahrt',
    showSchedules: 'Fahrpläne anzeigen',
    hideSchedules: 'Fahrpläne ausblenden',
    importToDatabase: 'In Datenbank importieren',
    dropzoneInstructions: 'Laden Sie eine JSON-Datei mit Busfahrtendaten hoch',
    dragAndDrop: 'Ziehen Sie Ihre Datei hierher',
    dropFileHere: 'Legen Sie die Datei hier ab',
    orClickToSelect: 'oder klicken Sie, um eine Datei auszuwählen',
    onlyJsonFiles: 'Es werden nur JSON-Dateien unterstützt',
    direction: 'Richtung',
    tripNumber: 'Fahrt Nr.',
    filterByDirection: 'Nach Richtung filtern',
    allDirections: 'Alle Richtungen',
    outbound: 'Hinfahrt',
    return: 'Rückfahrt',
    aller: 'Hinfahrt',
    retour: 'Rückfahrt',
    allSchedules: 'Alle Fahrpläne',
    outboundSchedules: 'Hinfahrt-Fahrpläne',
    returnSchedules: 'Rückfahrt-Fahrpläne',
    outboundTripNote:
      'Diese Hinfahrt geht von {from} nach {to} mit einer Dauer von {duration} Minuten.',
    returnTripNote:
      'Diese Rückfahrt geht von {from} nach {to} mit einer Dauer von {duration} Minuten.',
    passengerCount: 'Passagiere',
    bookingSummary: 'Buchungsübersicht',
    overallFillRate: 'Gesamtauslastung',
    totalPassengers: 'Gesamtzahl der Passagiere',
    trips: 'Fahrten',
    passengers: 'Passagiere',
    bookingLegend: 'Legende zum Buchungsstatus',
    plentySeats: 'Viele Plätze verfügbar',
    fillingUp: 'Füllt sich',
    almostFull: 'Fast voll',
    scheduleManager: 'Fahrplanmanager',
    selectBus: 'Bus auswählen',
    seats: 'Sitzplätze',
    viewSchedules: 'Fahrpläne anzeigen',
    editSchedule: 'Fahrplan bearbeiten',
    statusActive: 'Aktiv',
    statusAvailable: 'Verfügbar',
    statusFull: 'Voll',
    statusCancelled: 'Storniert',
    scheduleUpdateSuccess: 'Fahrplan erfolgreich aktualisiert',
    scheduleUpdateError: 'Fehler beim Aktualisieren des Fahrplans',
    totalRevenue: 'Gesamteinnahmen',
    occupancyRate: 'Auslastungsrate',
    busStats: 'Busstatistiken',
    activeBuses: 'Aktive Busse',
    totalSales: 'Gesamtverkäufe',
    fillRate: 'Füllrate',
    totalCapacity: 'Gesamtkapazität',
    allBuses: 'Alle Busse',
    observation: 'Beobachtung',
    seatsLeft: 'Sitzplätze übrig',
    customMessage: 'Kundennachricht',
    customMessagePlaceholder:
      'Sie können Bustickets in beide Richtungen buchen. Rückfahrkarten sind kostenlos, wenn Sie eine Hinfahrkarte kaufen.',
    customMessageHelp:
      'Diese Nachricht wird Kunden angezeigt, wenn sie Busse für diese Fahrt auswählen.',
  },
  // Role translations
  roles: {
    Owner: 'Inhaber',
    organizer: 'Organisator',
    promoter: 'PromoBooster',
    ambassador: 'Botschafter',
    bouncer: 'Türsteher',
    staff: 'Personal',
  },
  join_instadrink: 'ID Network beitreten',
  join_instadrink_network: 'ID Network beitreten',
  become_part_of_our_community: 'Werden Sie Teil unserer Gemeinschaft',
  i_would_like_to_invite_you_to_join_my_network:
    'Ich möchte dich einladen, meinem Netzwerk beizutreten!',
  loading_public_invite: 'Einladungslink wird geladen...',
  join_network_now: 'Netzwerk Beitreten',
  please_fix_form_errors: 'Bitte korrigieren Sie die Fehler im Formular',
  thank_you_for_joining_my_network: 'Vielen Dank für den Beitritt zu meinem Netzwerk 🥂',
  invitation_request_sent_successfully_check_your_email_finish_registration:
    'Einladungsanfrage erfolgreich gesendet. Bitte überprüfen Sie Ihre E-Mail 📧 um die Registrierung abzuschließen.',
  i_am_a: 'Rollen',
  processing_invitation_request: 'Einladungsanfrage wird verarbeitet...',
  tell_us_about_organization: 'Erzählen Sie uns von Ihrer Organisation',
  basic_info_subtitle:
    'Dies hilft uns, Ihre Organisation besser zu verstehen und Ihnen den bestmöglichen Service zu bieten.',
  // Invitation translations
  invitation: {
    you_are_invited_as: 'Sie sind eingeladen als',
    invitation_date: 'Einladungsdatum',
    invitation_details: 'Einladungsdetails',
    invitation_preview: 'Einladungsvorschau',
    please_fix_form_errors: 'Bitte beheben Sie die Formularfehler',
    error_loading_invitation: 'Fehler beim Laden der Einladung',
    status: {
      pending: 'Σε εκκρεμότητα',
      accepted: 'Έγινε αποδεκτή',
      canceled: 'Ακυρώθηκε',
      rejected: 'Απορρίφθηκε',
      expired: 'Έληξε',
    },
    you_can_now_login: 'Sie können sich jetzt anmelden',
    redirecting_to_dashboard: 'Weiterleitung zum Dashboard...',
    logging_in_automatically: 'Automatisches Anmelden...',
    go_to_login: 'Zur Anmeldung gehen',
    account_created_successfully: 'Konto erfolgreich erstellt',
    by: 'von',
    password_requirements: {
      min: 'Mindestens 8 Zeichen',
      uppercase: 'Mindestens ein Großbuchstabe',
      lowercase: 'Mindestens ein Kleinbuchstabe',
      number: 'Mindestens eine Zahl',
      special: 'Mindestens ein Sonderzeichen',
    },
  },
  tickets_in_reservation: 'Tickets in der Reservierung',
  payment_id: 'Zahlungs-ID',
  origin: 'Herkunft',
  bus_tickets: 'Bustickets',
  type: 'Typ',
  route: 'Route',
  departure_time: 'Abfahrtszeit',
  outbound: 'Hinfahrt',
  return: 'Rückfahrt',
  not_specified: 'Nicht angegeben',
  invalid_date: 'Ungültiges Datum',
  total_bus_tickets: 'Gesamt Bustickets',
  preordered: 'Vorbestellt',
  refunded: 'Erstattet',
  mixed: 'Gemischt',
  sent: 'Gesendet',
  not_sent: 'Nicht gesendet',
  view_details: 'Details anzeigen',

  reservation_details: 'Reservierungsdetails',
  reservation_id: 'Reservierungs-ID',
  client: 'Kunde',

  email: 'E-Mail',
  phone: 'Telefon',
  payment_information: 'Zahlungsinformationen',
  total_tickets: 'Tickets Insgesamt',

  notes: 'Notizen',
  edit_reservation: 'Reservierung bearbeiten',
  edit_ticket: 'Ticket bearbeiten',
  edit_client_information: 'Kundeninformationen bearbeiten',
  edit_ticket_info: 'Ticket-Informationen bearbeiten',
  edit_reservation_info: 'Reservierungsinformationen bearbeiten',
  edit_form: 'Formular',
  select_ticket_to_edit: 'Wählen Sie ein Ticket zum Bearbeiten',

  client_information: 'Kundeninformationen',
  ticket_holder_information: 'Ticketinhaber-Informationen',
  note_client_email_unchanged: 'Hinweis: Die E-Mail-Adresse des Kunden bleibt unverändert',

  update_failed: 'Aktualisierung fehlgeschlagen',
  save_changes: 'Änderungen Speichern',
  saving: 'Speichern...',
  ticket_updated_successfully: 'Ticket-Informationen erfolgreich aktualisiert',
  error_updating_ticket: 'Fehler beim Aktualisieren der Ticket-Informationen',
  invalid_email_format: 'Ungültiges E-Mail-Format',
  ticket: {
    insurance_options: 'Versicherungsoptionen',
    default_insurance_description: 'Schützen Sie Ihren Kauf mit unserer Rückerstattungsversicherung. Erhalten Sie eine Rückerstattung, wenn Sie Ihre Pläne ändern müssen.',
    enable_insurance: 'Rückerstattungsversicherungsoption für Kunden aktivieren',
    insurance_price: 'Versicherungspreis',
    max_refund_time: 'Maximale Rückerstattungszeit',
    refund_time_before_event:
      'Stunden vor Veranstaltungsbeginn, wenn die Rückerstattung verfügbar ist',
    insurance_description: 'Versicherungsbeschreibung',
    insurance_description_placeholder: 'Erklären Sie Ihren Kunden die Versicherungsbedingungen',
    insurance_description_help:
      'Definieren Sie die Versicherungseinstellungen für dieses Ticket. Kunden können diese Versicherung beim Checkout erwerben.',
  },
  ticketView: {
    insurance: 'Versicherung',
    insurance_available: 'Rückerstattungsversicherung verfügbar',
    insurance_price: 'Versicherungspreis',
    insurance_refund_time: 'Rückerstattungsfrist',
    hours_before_event: 'Stunden vor der Veranstaltung',
    insurance_description: 'Versicherungsbedingungen',
  },
  event_faqs: {
    title: 'Event FAQ',
    tabs: {
      sections: 'FAQ-Abschnitte',
      useful_links: 'Nützliche Links',
      contacts: 'Kontaktinformationen',
    },
    add_section: 'Abschnitt hinzufügen',
    edit_section: 'Abschnitt bearbeiten',
    section_title: 'Abschnittstitel',
    no_sections:
      "Noch keine FAQ-Abschnitte erstellt. Klicken Sie auf 'Abschnitt hinzufügen', um Ihren ersten Abschnitt zu erstellen.",
    items_count: '{{count}} Fragen',
    add_item: 'Frage hinzufügen',
    edit_item: 'Frage bearbeiten',
    question: 'Frage',
    answer: 'Antwort',
    no_items: 'Noch keine Fragen in diesem Abschnitt',
    confirm_delete_section:
      'Sind Sie sicher, dass Sie diesen Abschnitt löschen möchten? Alle Fragen in diesem Abschnitt werden gelöscht.',
    confirm_delete_item: 'Sind Sie sicher, dass Sie diese Frage löschen möchten?',

    add_link: 'Link hinzufügen',
    edit_link: 'Link bearbeiten',
    link_title: 'Link-Titel',
    link_url: 'URL',
    no_links:
      "Noch keine nützlichen Links erstellt. Klicken Sie auf 'Link hinzufügen', um Ihren ersten Link zu erstellen.",
    confirm_delete_link: 'Sind Sie sicher, dass Sie diesen Link löschen möchten?',
    invalid_url: 'Bitte geben Sie eine gültige URL ein (z.B. https://beispiel.de)',

    add_contact: 'Kontakt hinzufügen',
    edit_contact: 'Kontakt bearbeiten',
    contact_name: 'Name',
    contact_role: 'Rolle',
    contact_email: 'E-Mail',
    contact_phone: 'Telefon',
    no_contacts:
      "Noch keine Kontakte erstellt. Klicken Sie auf 'Kontakt hinzufügen', um Ihren ersten Kontakt zu erstellen.",
    confirm_delete_contact: 'Sind Sie sicher, dass Sie diesen Kontakt löschen möchten?',
    invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  },
  ticketsStats: {
    timeAnalysis: 'Zeitanalyse',
    dailySalesVelocity: 'Tägliche Verkaufsgeschwindigkeit',
    hourlySalesVelocity: 'Stündliche Verkaufsgeschwindigkeit',
    peakDays: 'Spitzenverkaufstage',
    peakHours: 'Spitzenverkaufsstunden',
    ticketsSold: 'Verkaufte Tickets',
    salesCount: 'Verkaufsanzahl',
    revenue: 'Umsatz',
    noTimeData: 'Keine Zeitdaten verfügbar',
    noHourlyDataForSelectedDay: 'Keine Stundendaten für den ausgewählten Tag verfügbar',
    noTicketData: 'Keine Ticketdaten für die Analyse verfügbar',
    day: 'Tag',
    hour: 'Stunde',
    selectDay: 'Tag auswählen',
    peakPeriods: 'Spitzenzeiten',
  },
  artistLineup: {
    title: 'Künstleraufstellung',
    manageLineup: 'Künstleraufstellung verwalten',
    currentLineup: 'Aktuelle Aufstellung',
    noArtists: 'Diesem Event wurden noch keine Künstler hinzugefügt.',
    addFirstArtist: 'Fügen Sie Ihren ersten Künstler hinzu',
    addArtist: 'Künstler hinzufügen',
    editArtist: 'Künstler bearbeiten',
    removeSuccess: 'Künstler erfolgreich entfernt',
    addSuccess: 'Künstler erfolgreich hinzugefügt',
    updateSuccess: 'Künstler erfolgreich aktualisiert',
    reorderSuccess: 'Aufstellung erfolgreich neu angeordnet',
    confirmRemove: 'Sind Sie sicher, dass Sie diesen Künstler entfernen möchten?',
    artistName: 'Künstlername',
    performanceTime: 'Auftrittszeit',
    biography: 'Biografie',
    imageUrl: 'Künstler-Bild-URL',
    socialLinks: 'Social Media Links',
    website: 'Webseite',
    followers: 'Follower',
    viewOnSpotify: 'Auf Spotify ansehen',
    generateLink: 'Mit Musikplattformen teilen',
    shareMusicPlatform: 'Mit Musikplattformen teilen',
    shareInfo:
      'Teilen Sie diese Links mit Musikplattformen, um Ihre Veranstaltung zu bewerben. Der Buchungslink ist für Benutzer zum Kauf von Tickets, während der API-Link Veranstaltungsdaten für die Integration mit Plattformen bereitstellt.',
    bookingLinkTitle: 'Buchungslink (Für Benutzer)',
    apiLinkTitle: 'API-Link (Für Musikplattformen)',
    securityNote: 'Sicherheitshinweis',
    securityDetails:
      'Diese Links enthalten ein einzigartiges Sicherheitstoken für Ihre Veranstaltung. Sie können den Link bei Bedarf jederzeit neu generieren.',
    linkCopied: 'Link in die Zwischenablage kopiert',
    searchArtist: 'Künstler auf Spotify suchen',
    searchSpotify: 'Suchen Sie nach einem Künstler auf Spotify',
    addArtistDetails: 'Künstlerdetails hinzufügen',
    manualEntry: 'Können Sie Ihren Künstler nicht finden? Manuell hinzufügen:',
    addManually: 'Künstler manuell hinzufügen',
    artistFound: 'Künstler auf Spotify gefunden! Füllen Sie unten alle zusätzlichen Details aus.',
    noResults: 'Keine Künstler mit diesem Namen gefunden',
    performsAt: 'Tritt auf um',
    notifySubscribers: 'Künstler-Follower benachrichtigen',
    notifySuccess: 'Benachrichtigung erfolgreich gesendet',
    confirmNotify:
      'Dadurch werden Abonnenten von Spotify-Künstlern in Ihrer Aufstellung über Ihre Veranstaltung informiert. Fortfahren?',
  },
  passculture: {
    subtitle: 'Pass Culture Integration',
    eventDetails: 'Veranstaltungsdetails',
    category: 'Kategorie',
    date: 'Datum',
    time: 'Zeit',
    venue: 'Veranstaltungsort',
    venueId: 'Veranstaltungsort-ID',
    saveVenue: 'Veranstaltungsort speichern',
    venueSaved: 'Veranstaltungsort erfolgreich gespeichert',
    passCultureInfo: 'Pass Culture Informationen',
    publishedOn: 'Veröffentlicht am',
    passCultureId: 'Pass Culture ID',
    status: 'Status',
    venueSelectionHelp:
      'Wählen Sie den Veranstaltungsort für diese Veranstaltung. Der Veranstaltungsort muss in Pass Culture registriert sein.',
    passCultureIntegration: 'Pass Culture Integration',
    notPublishedYet: 'Diese Veranstaltung wurde noch nicht bei Pass Culture veröffentlicht.',
    publishInfo:
      'Durch die Veröffentlichung bei Pass Culture wird diese Veranstaltung für berechtigte Nutzer der Pass Culture-Plattform verfügbar.',
    description: 'Beschreibung',
    currentStatus: 'Aktueller Status',
    passCultureDetails: 'Pass Culture Details',
    lastUpdated: 'Zuletzt aktualisiert',
    bookingsCount: 'Buchungen',
    remainingStock: 'Verfügbare Tickets',
    publicationDate: 'Veröffentlichungsdatum',
    lastModified: 'Zuletzt geändert',
    rejectionReason: 'Ablehnungsgrund',
    rawResponse: 'Rohdaten von Pass Culture',
    unknown: 'Unbekannt',
    noStatusData:
      'Keine Statusdaten verfügbar. Überprüfen Sie den Status, um aktuelle Informationen zu erhalten.',
    checkStatus: 'Status prüfen',
    ticketsMapping: 'Ticketzuordnung',
    ticketsMappingDescription:
      'Diese Tabelle zeigt, wie Ihre Veranstaltungstickets den Pass Culture-Kategorien zugeordnet sind.',
    price: 'Preis',
    available: 'Verfügbar',
    passCultureCategory: 'Pass Culture Kategorie',
    notMapped: 'Nicht zugeordnet',
    ticketsMappingNote:
      'Nur Tickets, die zum Verkauf verfügbar sind, werden den Pass Culture-Kategorien zugeordnet.',
    noTicketsAvailable: 'Für diese Veranstaltung sind keine Tickets verfügbar.',
    ticketInfo: 'Ticket-Informationen',
    moreCategories: 'Und weitere Kategorien...',
    publish: 'Bei Pass Culture veröffentlichen',
    refreshStatus: 'Status aktualisieren',
    publishDialog: {
      title: 'Bei Pass Culture veröffentlichen',
      description:
        'Sind Sie sicher, dass Sie diese Veranstaltung bei Pass Culture veröffentlichen möchten? Nach der Veröffentlichung wird die Veranstaltung für berechtigte Pass Culture-Nutzer verfügbar sein.',
      warning:
        'Hinweis: Die Veröffentlichung bei Pass Culture unterliegt der Prüfung durch deren Team und kann einige Zeit dauern, bis sie auf ihrer Plattform erscheint.',
    },
    tabs: {
      overview: 'Übersicht',
      status: 'Status',
      tickets: 'Tickets',
    },
    events: {
      notPublished: 'Nicht veröffentlicht',
      publishError: 'Veröffentlichungsfehler',
      published: 'Veröffentlicht',
    },
    success: {
      eventPublished: '{{name}} wurde erfolgreich bei Pass Culture veröffentlicht!',
      statusRefreshed: 'Status wurde erfolgreich aktualisiert.',
      emailSaved: 'Kontakt-E-Mail erfolgreich gespeichert',
      stocksAdded: 'Bestände wurden erfolgreich zu Pass Culture hinzugefügt',
    },
    errors: {
      eventNotFound:
        'Veranstaltung nicht gefunden oder Sie haben keine Berechtigung, sie anzusehen.',
      publishEventFailed:
        'Veröffentlichung der Veranstaltung bei Pass Culture fehlgeschlagen. Bitte versuchen Sie es erneut.',
      refreshStatusFailed:
        'Aktualisierung des Veranstaltungsstatus fehlgeschlagen. Bitte versuchen Sie es erneut.',
      invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      noContactEmail: 'Bitte geben Sie eine Kontakt-E-Mail an, bevor Sie veröffentlichen',
      addStocksFailed: 'Fehler beim Hinzufügen von Beständen zu Pass Culture',
    },
    contactEmail: 'Kontakt-E-Mail',
    contactEmailHelp:
      'Bitte geben Sie eine Kontakt-E-Mail für Pass Culture-Benutzer an. Diese E-Mail wird Benutzern auf der Pass Culture-Plattform angezeigt.',
    email: 'E-Mail',
    comingSoon: {
      title: 'Pass Culture Integration',
      message:
        'Die Integration mit Pass Culture wird in Kürze verfügbar sein. Mit dieser Funktion können Sie Ihre Veranstaltungen auf der Pass Culture-Plattform veröffentlichen. Bleiben Sie dran für Updates!',
    },
    addStocks: 'Bestände hinzufügen',
    stocksInformation: 'Bestandsinformationen',
    stocksAddedSuccess: '{{count}} Bestände wurden erfolgreich zu Pass Culture hinzugefügt',
    stocksCount: 'Gesamtbestände',
    lastStockUpdate: 'Letzte Aktualisierung',
    warnings: {
      noStocks: 'Diesem Ereignis wurden noch keine Bestände in Pass Culture hinzugefügt',
      noTicketsFound:
        'Keine Tickets für dieses Ereignis gefunden. Bitte erstellen Sie Tickets, bevor Sie Bestände hinzufügen.',
    },
    stocks: {
      dialogTitle: 'Bestände zu Pass Culture hinzufügen',
      step1: 'Bestände konfigurieren',
      step1Description:
        'Wählen Sie, wie Sie Bestände zu Pass Culture für dieses Ereignis hinzufügen möchten.',
      step2: 'Bestätigen und erstellen',
      step2Description:
        'Überprüfen Sie Ihre Auswahl und erstellen Sie die Bestände in Pass Culture.',
      step3: 'Erfolg',
      step3Description: 'Ihre Bestände wurden erfolgreich in Pass Culture erstellt.',
      useExistingTickets: 'Vorhandene Tickets meines Ereignisses verwenden',
      ticketsFound: 'Tickets gefunden',
      ticketsDescription:
        'Ihre Ereignistickets werden automatisch den Preiskategorien von Pass Culture zugeordnet.',
      willUseExistingTickets:
        'Sie erstellen {{count}} Bestände basierend auf Ihren vorhandenen Tickets',
      willCreateCustomStocks: 'Sie erstellen benutzerdefinierte Bestände in Pass Culture',
      createStocks: 'Bestände erstellen',
      successMessage: 'Bestände wurden erfolgreich in Pass Culture erstellt',
    },
  },
  dashboard: 'Dashboard',
  organizers: 'Veranstalter',
  organizerDetails: 'Veranstalterdetails',
  generalInfo: 'Allgemeine Informationen',
  backToOrganizers: 'Zurück zu Veranstaltern',
  backToOrganizer: 'Zurück zum Veranstalter',
  organizerNotFound: 'Veranstalter nicht gefunden',
  failedToFetchOrganizer: 'Fehler beim Abrufen der Veranstalterdaten',

  // Integration specific
  integrations: 'Integrationen',
  integrationsPageDescription:
    'Verbinden Sie Ihren Veranstalter mit externen Diensten, um Ihre Veranstaltungen zu verbessern und mehr Kunden zu erreichen.',
  comingSoon: 'Demnächst verfügbar',
  integrationComingSoon:
    'Die Integration mit {name} wird derzeit entwickelt und ist bald verfügbar.',

  // Integration descriptions
  passCultureIntegrationDescription:
    'Pass Culture ist eine mobile Anwendung und Website, die 18-Jährigen 300 € für kulturelle Güter und Erlebnisse anbietet. Verbinden Sie Ihren Veranstalter, um Veranstaltungsorte automatisch zu importieren und Ihre Veranstaltungen zu veröffentlichen.',
  ticketingIntegrationDescription:
    'Verbinden Sie Ihren Veranstalter mit beliebten Ticketing-Plattformen, um Veranstaltungsdaten zu synchronisieren, Ticketverkäufe zu verwalten und die Teilnahme über mehrere Kanäle zu verfolgen.',
  crmIntegrationDescription:
    'Integrieren Sie Customer Relationship Management-Systeme, um Ihre Kundenbasis zu verwalten, die Kommunikationshistorie zu verfolgen und Marketingkampagnen für Ihre Veranstaltungen zu erstellen.',

  // Tab labels
  ticketing: 'Ticketing',

  // Pass Culture specific translations
  passCultureIntegration: 'Pass Culture Integration',
  identifier: 'Kennung',
  noIdentifier: 'Keine Kennung konfiguriert',
  lastSynced: 'Letzte Synchronisierung',
  venues: 'Veranstaltungsorte',
  offerer: 'Anbieter',
  syncWithPassCulture: 'Mit Pass Culture synchronisieren',
  passCultureVenues: 'Pass Culture Veranstaltungsorte',
  passCultureOfferer: 'Pass Culture Anbieter',
  syncResults: 'Synchronisierungsergebnisse',
  noVenuesFound: 'Keine Veranstaltungsorte gefunden',
  noOffererData: 'Keine Anbieterdaten verfügbar',
  syncedVenues: '{{count}} Veranstaltungsorte erfolgreich synchronisiert',
  passCultureSyncSuccess:
    '{{count}} Veranstaltungsorte erfolgreich mit Pass Culture synchronisiert',
  passCultureSyncFailed: 'Synchronisierung mit Pass Culture fehlgeschlagen',
  syncFailed: 'Synchronisierung fehlgeschlagen',
  needSirenOrSiret:
    'Der Veranstalter benötigt eine SIREN- oder SIRET-Nummer zur Synchronisierung mit Pass Culture',
  close: 'Schließen',
  never: 'Nie',
  siren: 'SIREN',
  createdAt: 'Erstellt am',
  additionalInfo: 'Zusätzliche Informationen',
  notAvailable: 'Nicht verfügbar',
  goodies: {
    // Section Headers
    section: {
      title: 'Veranstaltungsartikel',
      description:
        'Verwalten Sie Artikel, die Kunden beim Buchen von Tickets für diese Veranstaltung kaufen können.',
    },

    // Actions
    actions: {
      new: 'Artikel hinzufügen',
      edit: 'Artikel bearbeiten',
      add: 'Artikel hinzufügen',
      save: 'Änderungen speichern',
      create: 'Artikel erstellen',
      delete: 'Artikel löschen',
      delete_confirm:
        'Sind Sie sicher, dass Sie diesen Artikel löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      manage: 'Artikel verwalten',
      hide: 'Artikel ausblenden',
      clear_cart: 'Warenkorb leeren',
      checkout: 'Zur Kasse',
      add_to_cart: 'In den Warenkorb',
      adding: 'Wird hinzugefügt...',
      remove: 'Entfernen',
      close: 'Schließen',
    },

    // Table Headers
    table: {
      name: 'Name',
      price: 'Preis',
      stock: 'Bestand',
      active: 'Aktiv',
      selected: 'ausgewählt',
      search: 'Artikel suchen...',
    },

    // Form Fields
    form: {
      name: 'Name',
      description: 'Beschreibung',
      price: 'Preis',
      stock: 'Bestand',
      image: 'Bild',
      active: 'Aktiv',
      in_stock: 'Auf Lager',
      out_of_stock: 'Nicht verfügbar',
      quantity: 'Menge',
    },

    // Cart
    cart: {
      title: 'Ihre Artikel',
      subtotal: 'Zwischensumme',
      checkout_notice: 'Die Artikel werden Ihrer Ticketreservierung hinzugefügt.',
      increase_quantity: 'Menge erhöhen',
      decrease_quantity: 'Menge verringern',
      open: 'Warenkorb öffnen',
    },

    // Tooltips
    tooltips: {
      name: 'Geben Sie den Namen des Artikels ein',
      description: 'Stellen Sie eine detaillierte Beschreibung des Artikels bereit',
      price: 'Legen Sie den Preis für diesen Artikel fest',
      stock: 'Geben Sie die verfügbare Menge dieses Artikels ein',
      image: 'Laden Sie ein Bild des Artikels hoch',
      active: 'Aktivieren Sie diese Option, um diesen Artikel zum Kauf verfügbar zu machen',
    },

    // Errors
    errors: {
      loading: 'Fehler beim Laden der Artikel',
      none_available: 'Keine Artikel für diese Veranstaltung verfügbar',
    },

    // Language tabs
    languages:
      'Übersetzungsregisterkarten (Englisch, Französisch, Spanisch, Portugiesisch, Deutsch)',
  },
  participantInfos: {
    know_from_attendees: 'Wie haben Sie von dieser Veranstaltung erfahren?',
    add_custom_field: 'Benutzerdefiniertes Feld hinzufügen',
    field_name: 'Feldname',
    field_type: 'Feldtyp',
    add_field: 'Feld hinzufügen',
    options: 'Optionen',
    add_option: 'Option hinzufügen',
    add: 'Hinzufügen',
    Text: 'Text',
    Number: 'Zahl',
    Email: 'E-Mail',
    Phone: 'Telefon',
    Date: 'Datum',
    'Multiple Choice': 'Multiple-Choice',
    Dropdown: 'Dropdown-Liste',
    Checkbox: 'Kontrollkästchen',
    type: 'Typ',
    Edit_data_success: 'Daten erfolgreich aktualisiert!',
    Edit_data_failed: 'Aktualisierung der Daten fehlgeschlagen!',
    no_options_added: 'Keine Optionen hinzugefügt',
    edit: 'Bearbeiten',
    options_for: 'Optionen für',
    enter_option_placeholder: 'Geben Sie eine Option ein und drücken Sie Enter oder Hinzufügen',
    multiple_choice_helper_text: 'Teilnehmer können eine Option aus der Liste auswählen.',
    dropdown_helper_text: 'Teilnehmer sehen ein Dropdown-Menü, um eine Option auszuwählen.',
    checkbox_helper_text: 'Teilnehmer können mehrere Optionen aus der Liste auswählen.',
    'Single Choice': 'Einzelauswahl',
    single_choice_explanation: 'Teilnehmer können NUR EINE Option aus der Liste auswählen.',
    multiple_choice_explanation: 'Teilnehmer können MEHRERE Optionen aus der Liste auswählen.',
    minimum_options_warning: 'Sie benötigen mindestens 2 Optionen für diesen Fragetyp.',
  },
  'Multi-day Festival Ticket': 'Mehrtägiges Festival-Ticket',
  'Allow ticket to be validated once per festival day':
    'Ticket einmal pro Festival-Tag validieren lassen',
  'Multi-day Festival Configuration': 'Mehrtägige Festival-Konfiguration',
  'This ticket can be validated once per festival day. Validations reset daily at the specified time.':
    'Dieses Ticket kann einmal pro Festival-Tag validiert werden. Validierungen werden täglich zur angegebenen Zeit zurückgesetzt.',
  Example: 'Beispiel',
  'Festival June 10-13, reset at 02:00 means:':
    'Festival 10.-13. Juni, Zurücksetzung um 02:00 bedeutet:',
  'Day 1: June 10 from event start until June 11 02:00':
    'Tag 1: 10. Juni von Event-Beginn bis 11. Juni 02:00',
  'Day 2: June 11 02:00 until June 12 02:00': 'Tag 2: 11. Juni 02:00 bis 12. Juni 02:00',
  'Day 3: June 12 02:00 until June 13 02:00': 'Tag 3: 12. Juni 02:00 bis 13. Juni 02:00',
  'Day 4: June 13 02:00 until event end': 'Tag 4: 13. Juni 02:00 bis Event-Ende',
  'Daily Reset Time': 'Tägliche Zurücksetzungszeit',
  'Time when daily validations reset (24h format). Recommended: 02:00 for festivals':
    'Zeit, zu der tägliche Validierungen zurückgesetzt werden (24h-Format). Empfohlen: 02:00 für Festivals',
  'Invalid time format. Use HH:MM (24h format)':
    'Ungültiges Zeitformat. Verwenden Sie HH:MM (24h-Format)',
  studio: {
    customization: {
      title: 'Studio-Anpassung',
      subtitle: 'Passen Sie an, wie Ihr Studio für Kunden und Besucher erscheint',
      resetTooltip: 'Auf Standardeinstellungen zurücksetzen',
      previewTooltip: 'Anpassungsvorschau',
      saveChanges: 'Änderungen Speichern',
      enableCustomization: 'Anpassung Aktivieren',
      enableDescription:
        'Wenn aktiviert, werden Ihre benutzerdefinierten Einstellungen auf die Studio-Seite angewendet',
      choosePersonality: 'Studio-Persönlichkeit Wählen',
      tabs: {
        layout: 'Layout',
        theme: 'Design',
        content: 'Inhalt',
      },
      layout: {
        heroStyle: 'Hero-Stil',
        heroStyles: {
          fullscreen: 'Vollbild',
          banner: 'Banner',
          split: 'Geteilt',
          minimal: 'Minimal',
        },
        logoPosition: 'Logo-Position',
        logoPositions: {
          overlayLeft: 'Überlagerung Links',
          center: 'Mitte',
          above: 'Oben',
          side: 'Seite',
        },
        ctaPosition: 'Call-to-Action Position',
        ctaPositions: {
          hero: 'In Hero',
          below: 'Unter Hero',
          floating: 'Schwebend',
          multiple: 'Mehrere Positionen',
        },
        sectionOrder: 'Abschnittsreihenfolge',
        sectionOrderDescription:
          'Die Reihenfolge, in der Abschnitte auf Ihrer Studio-Seite erscheinen',
      },
    },
    theme: {
      title: 'Studio-Design',
      subtitle:
        'Verwalten Sie die visuelle Identität Ihres Studios mit benutzerdefiniertem Logo und Titelbildern',
      logoSection: {
        title: 'Studio-Logo',
        description: 'Laden Sie Ihr Studio-Logo hoch. Empfohlene Größe: 256x256px, max 2MB',
        changeLogo: 'Logo Ändern',
        uploadLogo: 'Logo Hochladen',
        removeLogo: 'Logo Entfernen',
        clickToPreview: 'Zum Vorschauen klicken',
      },
      coverSection: {
        title: 'Titelbild',
        description: 'Laden Sie Ihr Studio-Titelbild hoch. Empfohlene Größe: 1200x400px, max 5MB',
        changeCoverImage: 'Titelbild Ändern',
        uploadCoverImage: 'Titelbild Hochladen',
        removeCoverImage: 'Titelbild Entfernen',
      },
      guidelines: {
        title: 'Design-Richtlinien',
        logoRequirements: 'Logo-Anforderungen',
        logoSpecs: {
          squareFormat: 'Quadratisches Format (1:1 Verhältnis) empfohlen',
          minMaxSize: 'Minimum 256x256px, Maximum 512x512px',
          format: 'PNG oder JPG Format',
          maxFileSize: 'Maximale Dateigröße: 2MB',
          transparentBg: 'Transparenter Hintergrund für PNG bevorzugt',
        },
        coverRequirements: 'Titelbild-Anforderungen',
        coverSpecs: {
          landscapeFormat: 'Querformat (3:1 Verhältnis) empfohlen',
          minSize: 'Minimum 1200x400px',
          format: 'PNG oder JPG Format',
          maxFileSize: 'Maximale Dateigröße: 5MB',
          highQuality: 'Hochwertige Bilder präsentieren sich besser',
        },
      },
      messages: {
        logoSizeError: 'Die Logo-Dateigröße muss kleiner als 2MB sein',
        coverSizeError: 'Die Titelbild-Dateigröße muss kleiner als 5MB sein',
        invalidImageFile: 'Bitte wählen Sie eine gültige Bilddatei aus',
        logoUpdated: 'Logo erfolgreich aktualisiert!',
        logoUpdateFailed: 'Logo konnte nicht aktualisiert werden',
        coverUpdated: 'Titelbild erfolgreich aktualisiert!',
        coverUpdateFailed: 'Titelbild konnte nicht aktualisiert werden',
        confirmRemoveLogo: 'Sind Sie sicher, dass Sie das Studio-Logo entfernen möchten?',
        confirmRemoveCover: 'Sind Sie sicher, dass Sie das Titelbild entfernen möchten?',
        logoRemoved: 'Logo erfolgreich entfernt!',
        logoRemoveFailed: 'Logo konnte nicht entfernt werden',
        coverRemoved: 'Titelbild erfolgreich entfernt!',
        coverRemoveFailed: 'Titelbild konnte nicht entfernt werden',
      },
      preview: {
        logoTitle: 'Logo-Vorschau',
        coverTitle: 'Titelbild-Vorschau',
        close: 'Schließen',
      },
    },
    showcase: {
      title: 'Musik-Showcase',
      settings: {
        title: 'Musik-Showcase Einstellungen',
        subtitle: 'Konfigurieren Sie den Musik-Showcase Ihres Studios für Kunden',
        saveSettings: 'Einstellungen Speichern',
        enableShowcase: 'Musik-Showcase Aktivieren',
        enableDescription:
          'Wenn aktiviert, wird Ihr Musik-Showcase für Kunden auf Ihrem Studio-Profil sichtbar sein',
        showcaseTitle: 'Showcase-Titel',
        showcaseTitlePlaceholder: 'z.B. Unsere Neuesten Produktionen',
        showcaseDescription: 'Showcase-Beschreibung',
        showcaseDescriptionPlaceholder: 'Beschreiben Sie Ihren Musik-Showcase...',
      },
      tracks: {
        title: 'Musiktitel',
        subtitle: 'Fügen Sie Musiktitel hinzu, um die Arbeit Ihres Studios zu präsentieren',
        addTrack: 'Titel Hinzufügen',
        addFirstTrack: 'Ersten Titel Hinzufügen',
        editTrack: 'Titel Bearbeiten',
        noTracksYet:
          'Noch keine Titel hinzugefügt. Fügen Sie Ihren ersten Titel hinzu, um zu beginnen!',
        enableShowcaseFirst: 'Aktivieren Sie den Musik-Showcase oben, um Titel hinzuzufügen',
        trackCount: 'Musiktitel ({{count}})',
        hidden: 'Versteckt',
        by: 'von',
      },
      trackDialog: {
        addTitle: 'Titel Hinzufügen',
        editTitle: 'Titel Bearbeiten',
        trackTitle: 'Titel *',
        trackTitlePlaceholder: 'Titel eingeben',
        artist: 'Künstler',
        artistPlaceholder: 'Künstler- oder Bandname',
        platform: 'Plattform *',
        url: 'URL *',
        description: 'Beschreibung',
        descriptionPlaceholder: 'Optionale Beschreibung oder Notizen zu diesem Titel',
        cancel: 'Abbrechen',
        add: 'Hinzufügen',
        update: 'Aktualisieren',
        addTrackButton: 'Titel Hinzufügen',
        updateTrackButton: 'Titel Aktualisieren',
      },
      platforms: {
        youtube: 'YouTube',
        spotify: 'Spotify',
        soundcloud: 'SoundCloud',
        apple_music: 'Apple Music',
        bandcamp: 'Bandcamp',
        other: 'Andere',
      },
      urlHints: {
        youtube:
          'z.B. https://www.youtube.com/watch?v=dQw4w9WgXcQ oder https://youtu.be/dQw4w9WgXcQ',
        spotify: 'z.B. https://open.spotify.com/track/4uLU6hMCjMI75M1A2tKUQC',
        soundcloud: 'z.B. https://soundcloud.com/künstler/titel-name',
        apple_music: 'z.B. https://music.apple.com/us/album/song-name/id123456789?i=123456789',
        bandcamp: 'z.B. https://künstler.bandcamp.com/track/song-name',
        other: 'Beliebige Musikplattform-URL eingeben',
      },
      actions: {
        openLink: 'Link öffnen',
        hideTrack: 'Titel verstecken',
        showTrack: 'Titel anzeigen',
        editTrack: 'Titel bearbeiten',
        removeTrack: 'Titel entfernen',
      },
      messages: {
        settingsSaved: 'Showcase-Einstellungen erfolgreich gespeichert!',
        settingsSaveFailed: 'Showcase-Einstellungen konnten nicht gespeichert werden',
        enterTitle: 'Bitte geben Sie einen Titel ein',
        enterUrl: 'Bitte geben Sie eine URL ein',
        invalidUrl: 'Ungültiges {{platform}} URL-Format',
        trackUpdated: 'Titel erfolgreich aktualisiert!',
        trackAdded: 'Titel erfolgreich hinzugefügt!',
        trackSaveFailed: 'Titel konnte nicht gespeichert werden',
        confirmRemove: 'Sind Sie sicher, dass Sie "{{title}}" aus dem Showcase entfernen möchten?',
        trackRemoved: 'Titel erfolgreich entfernt!',
        trackRemoveFailed: 'Titel konnte nicht entfernt werden',
        trackHidden: 'Titel erfolgreich versteckt!',
        trackShown: 'Titel erfolgreich angezeigt!',
        trackToggleFailed: 'Sichtbarkeit des Titels konnte nicht geändert werden',
        tracksReordered: 'Titel erfolgreich neu angeordnet!',
        tracksReorderFailed: 'Titel konnten nicht neu angeordnet werden',
      },
    },
    availability: {
      title: 'Studio-Verfügbarkeit',
      subtitle:
        'Konfigurieren Sie die Arbeitszeiten Ihres Studios, Buchungszeitfenster und Verfügbarkeitsregeln',
      loading: 'Verfügbarkeitseinstellungen laden...',
      loadError:
        'Verfügbarkeitseinstellungen konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.',
      tabs: {
        workingHours: 'Arbeitszeiten',
        bookingRules: 'Buchungsregeln',
        timeSlots: 'Zeitfenster',
      },
      daysOfWeek: {
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
      },
      workingHours: {
        title: 'Wochenplan',
        description:
          'Legen Sie die Öffnungszeiten Ihres Studios für jeden Wochentag fest. Aktivieren Sie den 24-Stunden-Modus oder legen Sie Zeiten fest, die über Mitternacht gehen (z.B. 22:00 bis 06:00 am nächsten Tag)',
        startTime: 'Startzeit',
        endTime: 'Endzeit',
        is24Hours: '24h',
        nextDay: 'nächster Tag',
        crossMidnightSchedule: 'Zeitplan über Mitternacht:',
      },
      crossDayPolicy: {
        title: 'Mehrtägige Buchungsrichtlinie',
        enableCrossDayBookings: 'Mehrtägige Buchungen Aktivieren',
        enableDescription:
          'Buchungen ermöglichen, die über Mitternacht hinausgehen (z.B. 23:00 bis 02:00)',
        maxCrossDayHours: 'Maximale Stunden Mehrtägig',
        maxCrossDayHoursHelp:
          'Maximale Anzahl von Stunden, die eine Buchung über Tage hinweg dauern kann',
        allowWeekendCrossover: 'Wochenendübergang Erlauben',
        allowWeekendCrossoverHelp:
          'Buchungen ermöglichen, die vom Wochenende auf Wochentage übergehen oder umgekehrt',
        requireSameDayStart: 'Gleicher Tag Start Erforderlich',
        requireSameDayStartHelp: 'Buchung muss am gleichen Kalendertag beginnen und enden',
      },
      bookingRules: {
        title: 'Buchungskonfiguration',
        description: 'Buchungsregeln und -beschränkungen konfigurieren',
        advanceBookingDays: 'Vorlaufzeit Buchung (Tage)',
        advanceBookingDaysHelp: 'Wie viele Tage im Voraus können Kunden buchen',
        minBookingNotice: 'Mindestankündigung (Stunden)',
        minBookingNoticeHelp: 'Mindeststunden vor der Buchung',
        maxBookingDuration: 'Maximale Sitzungsdauer (Minuten)',
        maxBookingDurationHelp: 'Maximale Buchungsdauer',
        bufferTime: 'Pufferzeit (Minuten)',
        bufferTimeHelp: 'Pausenzeit zwischen Buchungen',
        autoApproveBookings: 'Buchungen automatisch genehmigen',
        autoApproveBookingsHelp:
          'Buchungsanfragen automatisch ohne manuelle Überprüfung genehmigen',
        allowBackToBackBookings: 'Aufeinanderfolgende Buchungen erlauben',
        allowBackToBackBookingsHelp: 'Ermöglichen, aufeinanderfolgende Buchungen zu planen',
      },
      timeSlots: {
        title: 'Zeitfenster-Konfiguration',
        description: 'Buchungszeitfenster und Intervalle konfigurieren',
        timeSlotUnit: 'Zeitfenster-Einheit',
        timeSlotDuration: 'Standard-Zeitfenster-Dauer (Minuten)',
        timeSlotDurationHelp: 'Standarddauer für Buchungszeitfenster',
        info: 'Zeitfenster werden basierend auf Ihren Arbeitszeiten und der ausgewählten Zeiteinheit generiert. Kunden können bei der Buchung aus verfügbaren Zeitfenstern wählen.',
        units: {
          '15min': '15 Minuten',
          '30min': '30 Minuten',
          '1hr': '1 Stunde',
        },
      },
      validation: {
        advanceBookingDaysRequired: 'Vorlaufzeit Buchung ist erforderlich',
        minBookingNoticeRequired: 'Mindestankündigung ist erforderlich',
        maxBookingDurationRequired: 'Maximale Buchungsdauer ist erforderlich',
        timeSlotDurationRequired: 'Zeitfenster-Dauer ist erforderlich',
        bufferTimeRequired: 'Pufferzeit ist erforderlich',
      },
      actions: {
        reset: 'Zurücksetzen',
        saveSettings: 'Einstellungen Speichern',
      },
      messages: {
        settingsSaved: 'Verfügbarkeitseinstellungen erfolgreich gespeichert!',
        saveFailed: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
      },
    },
    settings: {
      title: 'Allgemeine Einstellungen',
      subtitle: 'Konfigurieren Sie die Einstellungen und Präferenzen Ihres Studios',
      tabs: {
        general: 'Allgemein',
        bookingRules: 'Buchungsregeln',
        notifications: 'Benachrichtigungen',
        studioBusiness: 'Studio-Geschäft',
      },
      general: {
        studioName: 'Studio-Name',
        studioNameHelp: 'Der Name Ihres Studios, wie er den Kunden angezeigt wird',
        emailAddress: 'E-Mail-Adresse',
        emailAddressHelp: 'Haupt-E-Mail-Adresse für die Studio-Kommunikation',
        phoneNumber: 'Telefonnummer',
        phoneNumberHelp: 'Kontaktnummer für Kundenanfragen',
        address: 'Adresse',
        addressHelp: 'Physische Adresse des Studios',
        description: 'Beschreibung',
        descriptionHelp: 'Kurze Beschreibung Ihres Studios und seiner Dienstleistungen',
      },
      bookingRules: {
        title: 'Buchungsregeln',
        description: 'Konfigurieren Sie, wie Kunden Ihr Studio buchen können',
        requiresApproval: 'Erfordert Genehmigung',
        requiresApprovalHelp: 'Buchungen manuell vor der Bestätigung genehmigen',
        autoApprove: 'Buchungen Automatisch Genehmigen',
        autoApproveHelp: 'Buchungsanfragen automatisch ohne manuelle Überprüfung genehmigen',
        cancellationPolicy: 'Stornierungsrichtlinie',
        cancellationPolicyHelp: 'Details Ihrer Stornierungsrichtlinie',
        cancellationWindow: 'Stornierungsfenster (Stunden)',
        cancellationWindowHelp: 'Stunden vor der Buchung für kostenlose Stornierung',
        depositRequired: 'Anzahlung Erforderlich',
        depositRequiredHelp: 'Eine Anzahlung zur Bestätigung von Buchungen verlangen',
        depositPercentage: 'Anzahlungsprozentsatz',
        depositPercentageHelp: 'Prozentsatz der Gesamtsumme, der als Anzahlung erforderlich ist',
        minAdvanceBooking: 'Minimale Vorlaufzeit (Stunden)',
        minAdvanceBookingHelp: 'Mindeststunden im Voraus zum Buchen',
        maxAdvanceBooking: 'Maximale Vorlaufzeit (Tage)',
        maxAdvanceBookingHelp: 'Maximale Tage im Voraus zum Buchen',
        bufferTime: 'Vorbereitungszeit (Minuten)',
        bufferTimeHelp: 'Zeit zwischen Buchungen zur Vorbereitung',
      },
      notifications: {
        title: 'Benachrichtigungseinstellungen',
        description: 'Verwalten Sie, wie Sie und Ihre Kunden Benachrichtigungen erhalten',
        emailNotifications: 'E-Mail-Benachrichtigungen',
        smsNotifications: 'SMS Notifications',
        emailNotificationsHelp: 'E-Mail-Benachrichtigungen aktivieren',
        smsNotificationsHelp: 'Benachrichtigungen per SMS erhalten',
        whatsappNotifications: 'WhatsApp-Benachrichtigungen',
        whatsappNotificationsHelp: 'WhatsApp-Benachrichtigungen aktivieren',
        customerNotifications: 'Kundenbenachrichtigungen',
        notifyOnBooking: 'Bei Neuer Buchung Benachrichtigen',
        notifyOnBookingHelp:
          'Benachrichtigung an den Kunden senden, wenn eine Buchung erstellt wird',
        notifyOnStatusChange: 'Bei Statusänderung Benachrichtigen',
        notifyOnStatusChangeHelp: 'Kunden benachrichtigen, wenn sich der Buchungsstatus ändert',
        notifyBeforeSession: 'Erinnerung Vor der Sitzung',
        notifyBeforeSessionHelp: 'Erinnerung vor der geplanten Sitzung senden',
        ownerNotifications: 'Eigentümerbenachrichtigungen',
        notifyOwnerOnBooking: 'Eigentümer Bei Neuen Buchungen Benachrichtigen',
        notifyOwnerOnBookingHelp: 'Studio-Eigentümer über neue Buchungsanfragen informieren',
        notifyOwnerOnCancellation: 'Eigentümer Bei Stornierungen Benachrichtigen',
        notifyOwnerOnCancellationHelp: 'Studio-Eigentümer über Buchungsstornierungen informieren',
      },
      studioBusiness: {
        title: 'Studio-Geschäftseinstellungen',
        description:
          'Verwalten Sie die öffentliche Sichtbarkeit und Geschäftseinstellungen Ihres Studios',
        isPublic: 'Öffentliches Studio',
        isPublicHelp: 'Das Studio in öffentlichen Suchen und Listen sichtbar machen',
        acceptBookings: 'Nimmt Buchungen An',
        acceptBookingsOn: 'Ihr Studio nimmt neue Buchungsanfragen an',
        acceptBookingsOff: 'Neue Buchungen sind vorübergehend deaktiviert',
        acceptsBookings: 'Nimmt Buchungen An',
        acceptsBookingsHelp: 'Neue Buchungsanfragen annehmen',
        musicStyles: 'Musikstile',
        musicStylesHelp:
          'Wählen Sie die Musikstile aus, die Ihr Studio unterstützt (halten Sie Strg/Cmd für Mehrfachauswahl gedrückt)',
        country: 'Land',
        currency: 'Währung',
        timezone: 'Zeitzone',
        language: 'Sprache',
        websiteUrl: 'Website-URL',
        websiteUrlHelp: 'Website Ihres Studios (optional)',
        socialMedia: 'Soziale Medien',
        socialMediaHelp: 'Links zu Ihren Social-Media-Profilen',
      },
      validation: {
        nameRequired: 'Studio-Name ist erforderlich',
        emailRequired: 'E-Mail-Adresse ist erforderlich',
        emailInvalid: 'Ungültige E-Mail-Adresse',
        phoneRequired: 'Telefonnummer ist erforderlich',
        addressRequired: 'Adresse ist erforderlich',
      },
      messages: {
        settingsSaved: 'Einstellungen erfolgreich gespeichert!',
        saveFailed: 'Einstellungen konnten nicht gespeichert werden',
        notificationsSaved: 'Benachrichtigungseinstellungen erfolgreich gespeichert!',
        notificationsSaveFailed: 'Benachrichtigungseinstellungen konnten nicht gespeichert werden',
      },
    },
  },
  method: 'Methode',

  manual: 'Manuell',
  full: 'Vollständig',
  deposit: 'Anzahlung',
  hold: 'Zahlungsvorbehalt',
};

export default gr;
